/* Ukrainian (default) dictionary. Placeholders: {name}. Plural forms: "one|few|many" with {n}. */
import { fopsUk } from './fops'
import { labshipUk } from './labship'
import { incidentsUk } from './incidents'
import { arrivalsUk } from './arrivals'
import { bloodbankUk } from './bloodbank'
import { supplyUk } from './supply'
import { supplyEnoteUk } from './supplyEnote'
import { kbUk } from './kb'
import { registersUk } from './registers'
import { cashopsUk } from './cashops'
import { checkboxUk } from './checkbox'
import { basUk } from './bas'
import { callcenterUk } from './callcenter'
import { fincontrolUk } from './fincontrol'
import { mgmtUk } from './mgmt'
import { consentsUk } from './consents'
import { vritEnoteUk } from './vritenote'
import { pwaUk } from './pwa'
import { rolloutUk } from './rollout'
import { callqualityUk } from './callquality'
import { clinqUk } from './clinq'
import { moneyUk } from './money'
import { personnelUk } from './personnel'
import { registryUk } from './registry'
import { helpUk } from './help'

export const uk = {
  ...fopsUk,
  ...labshipUk,
  ...incidentsUk,
  ...arrivalsUk,
  ...bloodbankUk,
  ...supplyUk,
  ...supplyEnoteUk,
  ...kbUk,
  ...registersUk,
  ...cashopsUk,
  ...checkboxUk,
  ...basUk,
  ...callcenterUk,
  ...fincontrolUk,
  ...mgmtUk,
  ...consentsUk,
  ...vritEnoteUk,
  ...rolloutUk,
  ...pwaUk,
  ...callqualityUk,
  ...clinqUk,
  ...moneyUk,
  ...personnelUk,
  ...registryUk,
  ...helpUk,
  // common
  'common.actions': 'Дії',
  'common.all': 'Усі',
  'common.any': 'Будь-який',
  'common.apply': 'Застосувати',
  'common.back': 'Назад',
  'common.cancel': 'Скасувати',
  'common.close': 'Закрити',
  'common.copied': 'Скопійовано',
  'common.copy': 'Копіювати',
  'common.copyFailed': 'Не вдалося скопіювати',
  'common.delete': 'Видалити',
  'common.done': 'Готово',
  'common.edit': 'Редагувати',
  'common.failed': 'Помилка',
  'common.me': 'я',
  'common.min': 'хв',
  'common.no': 'ні',
  'common.noData': 'Даних поки немає',
  'common.nothingFound': 'Нічого не знайдено',
  'common.ok': 'Успішно',
  'common.open': 'Відкрити',
  'common.openAll': 'Відкрити все',
  'common.reset': 'Скинути',
  'common.retry': 'Спробувати ще',
  'common.save': 'Зберегти',
  'common.updating': 'Оновлення…',
  'common.undo': 'Повернути',
  'common.yes': 'так',

  // navigation
  'nav.main': 'Головна навігація',
  'nav.today': 'Сьогодні',
  'nav.schedule': 'Розклад',
  'nav.journeys': 'Візити',
  'nav.linkReview': 'Перевірка зв’язків',
  'nav.clients': 'Клієнти й тварини',
  'nav.doctor': 'Лікар',
  'nav.calls': 'Дзвінки',
  'nav.missed': 'Втрачені можливості',
  'nav.inbox': 'Повідомлення',
  'nav.finance': 'Фінанси',
  'nav.quality': 'Якість',
  'nav.marketing': 'Маркетинг',
  'nav.tasks': 'Завдання',
  'nav.insights': 'Інсайти',
  'nav.admin': 'Адміністрування',
  'nav.users': 'Користувачі й ролі',
  'nav.connectors': 'Конектори',
  'nav.sync': 'Синхронізація',
  'nav.jobs': 'Фонові задачі',
  'nav.rooms': 'Кабінети й камери',
  'nav.operators': 'Оператори',
  'nav.clientapp': 'Клієнтський застосунок',
  'nav.settings': 'Налаштування',
  'nav.audit': 'Журнал аудиту',
  'nav.system': 'Стан системи',
  'nav.profile': 'Профіль',
  'nav.collapse': 'Згорнути',
  'nav.expand': 'Розгорнути',
  'nav.openMenu': 'Відкрити меню',

  // search / palette
  'search.open': 'Пошук і команди',
  'search.placeholder': 'Пошук клієнтів, тварин, телефонів, дій…',
  'search.paletteHint': 'Введіть ім’я, телефон, кличку або команду…',
  'search.nothing': 'Нічого не знайдено',
  'search.results': 'Результати',
  'search.quick': 'Швидкі дії',
  'search.navigation': 'Перейти',
  'search.actions': 'Дії',
  'search.moduleMissing': 'Глобальний пошук ще не підключено — доступні навігація й дії.',
  'search.toggleTheme': 'Змінити тему',
  'search.type.client': 'клієнт',
  'search.type.pet': 'тварина',
  'search.type.call': 'дзвінок',
  'search.type.task': 'завдання',
  'search.type.visit': 'візит',
  'search.type.appointment': 'запис',

  // states & errors
  'state.moduleMissing': 'Модуль ще не підключено',
  'state.moduleMissingHint': 'Цей розділ запрацює, щойно на сервері з’явиться дія',
  'state.noAccess': 'Немає доступу',
  'state.noAccessHint': 'Вашій ролі цей розділ недоступний. Зверніться до адміністратора.',
  'state.error': 'Щось пішло не так',
  'state.notFound': 'Сторінку не знайдено',
  'state.notFoundHint': 'Можливо, посилання застаріло або сторінку перенесено.',
  'state.goHome': 'На головну',
  'error.generic': 'Сталася помилка. Спробуйте ще раз.',
  'error.moduleMissing': 'Модуль ще не підключено',
  'error.forbidden': 'Недостатньо прав для цієї дії',
  'error.network': 'Немає зв’язку з сервером',
  'error.rateLimited': 'Забагато спроб. Зачекайте хвилину.',
  'error.lastAdmin': 'Не можна прибрати роль або вимкнути останнього активного суперадміністратора. Спершу призначте іншого.',
  'error.emailTaken': 'Користувач з таким email уже існує',
  'error.locked': 'Забагато невдалих спроб. Обліковий запис тимчасово заблоковано на 15 хвилин.',
  'error.inviteInvalid': 'Запрошення недійсне або прострочене. Попросіть адміністратора надіслати нове.',
  'error.passwordPolicy': 'Пароль не відповідає вимогам',
  'error.currentPassword': 'Поточний пароль неправильний',
  'error.totpInvalid': 'Неправильний код підтвердження',
  'validation.required': 'Обов’язкове поле',
  'validation.email': 'Некоректний email',
  'validation.invalid': 'Некоректне значення',
  'validation.max': 'Не більше {n} символів',
  'validation.maxValue': 'Не більше {n}',
  'validation.min': 'Щонайменше {n}',

  // auth
  'login.title': 'Вхід для персоналу',
  'login.subtitle': 'Увійдіть робочим email клініки',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.submit': 'Увійти',
  'login.verify': 'Підтвердити',
  'login.invalid': 'Неправильний email або пароль',
  'login.totpTitle': 'Двофакторна перевірка',
  'login.totpHint': 'Введіть 6-значний код із застосунку автентифікації.',
  'login.totpCode': 'Код підтвердження',
  'login.inviteOnly': 'Доступ лише за запрошенням адміністратора.',
  'login.heroTitle': 'Уся історія візиту — в одному місці',
  'login.heroText': 'Дзвінки, записи, кабінет, лікування, оплата й рекомендації — зв’язані в одну подорож пацієнта.',
  'invite.title': 'Ласкаво просимо до Dovira',
  'invite.subtitle': 'Створіть пароль, щоб активувати обліковий запис.',
  'invite.password': 'Новий пароль',
  'invite.confirm': 'Повторіть пароль',
  'invite.submit': 'Активувати обліковий запис',
  'invite.mfaNote': 'Після входу рекомендуємо увімкнути двофакторну автентифікацію у профілі.',
  'invite.doneTitle': 'Обліковий запис активовано',
  'invite.doneText': 'Тепер увійдіть як {email}.',
  'invite.goLogin': 'Перейти до входу',
  'password.rules': 'Вимоги до пароля',
  'password.ruleLength': 'щонайменше 10 символів',
  'password.ruleUpper': 'велика літера',
  'password.ruleLower': 'мала літера',
  'password.ruleDigit': 'цифра',
  'password.policy': 'Пароль не відповідає вимогам',
  'password.mismatch': 'Паролі не збігаються',

  // user menu / theme
  'user.menu': 'Меню користувача',
  'user.profile': 'Мій профіль',
  'user.language': 'Мова',
  'user.theme': 'Тема',
  'user.shortcuts': 'Гарячі клавіші',
  'user.logout': 'Вийти',
  'theme.light': 'Світла',
  'theme.dark': 'Темна',
  'theme.system': 'Як у системі',
  'live.on': 'Оновлення наживо',
  'live.connecting': 'Підключення…',
  'live.off': 'Офлайн',
  'shortcuts.title': 'Гарячі клавіші',
  'shortcuts.palette': 'Пошук і команди',
  'shortcuts.search': 'Швидкий пошук',
  'shortcuts.newTask': 'Нове завдання',
  'shortcuts.sidebar': 'Згорнути бічну панель',
  'shortcuts.help': 'Довідка по сторінці (також F1)',
  'shortcuts.jk': 'Наступний / попередній (черга)',
  'shortcuts.yn': 'Підтвердити / відхилити зв’язок',
  'notifications.title': 'Сповіщення',
  'notifications.titleUnread': 'Сповіщення, непрочитаних: {n}',
  'notifications.empty': 'Нових сповіщень немає',
  'notifications.markAll': 'Прочитати все',
  'notifications.unread': 'непрочитане',
  'notifications.urgent': 'терміново',

  // tables / calendar
  'table.columns': 'Колонки',
  'table.empty': 'Немає записів',
  'table.page': 'Сторінка {page} з {pages}',
  'table.prev': 'Попередня сторінка',
  'table.next': 'Наступна сторінка',
  'calendar.prev': 'Назад',
  'calendar.next': 'Вперед',
  'calendar.today': 'Сьогодні',
  'calendar.kyiv': 'Час — Київ',
  'calendar.noDue': 'без терміну: {n}',
  'calendar.more': 'ще {n}',
  'calendar.addOn': 'Додати завдання на {day}',

  // tasks
  'tasks.subtitle': 'Доручення команди: список, дошка, календар і повторювані завдання',
  'tasks.new': 'Нове завдання',
  'tasks.create': 'Створити',
  'tasks.created': 'Завдання створено',
  'tasks.saved': 'Зміни збережено',
  'tasks.edit': 'Редагувати завдання',
  'tasks.detail': 'Завдання',
  'tasks.views': 'Вигляд',
  'tasks.view.list': 'Список',
  'tasks.view.board': 'Дошка',
  'tasks.view.calendar': 'Календар',
  'tasks.view.series': 'Повторювані',
  'tasks.search': 'Пошук завдань',
  'tasks.mine': 'Мої',
  'tasks.overdueFilter': 'Прострочені',
  'tasks.filter.open': 'Відкриті',
  'tasks.filter.all': 'Усі статуси',
  'tasks.status.todo': 'До виконання',
  'tasks.status.in_progress': 'В роботі',
  'tasks.status.review': 'На перевірці',
  'tasks.status.done': 'Виконано',
  'tasks.status.cancelled': 'Скасовано',
  'tasks.priority.low': 'Низький',
  'tasks.priority.medium': 'Середній',
  'tasks.priority.high': 'Високий',
  'tasks.priority.critical': 'Критичний',
  'tasks.field.title': 'Назва',
  'tasks.field.description': 'Опис',
  'tasks.field.priority': 'Пріоритет',
  'tasks.field.status': 'Статус',
  'tasks.field.assignee': 'Виконавець',
  'tasks.field.due': 'Термін',
  'tasks.field.visibility': 'Видимість',
  'tasks.field.link': 'Пов’язати з',
  'tasks.field.linkId': 'ID об’єкта',
  'tasks.field.watchers': 'Спостерігачі',
  'tasks.field.creator': 'Автор',
  'tasks.titlePlaceholder': 'Наприклад: передзвонити власнику Барсика',
  'tasks.visibility.team': 'Команда',
  'tasks.visibility.private': 'Лише я',
  'tasks.unassigned': 'Не призначено',
  'tasks.kyivTime': 'Час за Києвом',
  'tasks.overdue': 'Прострочено',
  'tasks.recurring': 'Повторюване',
  'tasks.system': 'Система',
  'tasks.updated': 'Оновлено',
  'tasks.created_at': 'Створено',
  'tasks.completed_at': 'Завершено',
  'tasks.watch': 'Стежити',
  'tasks.unwatch': 'Не стежити',
  'tasks.watched': 'Ви стежите за завданням',
  'tasks.unwatched': 'Ви більше не стежите',
  'tasks.watchersCount': '{n} осіб',
  'tasks.occurrences': 'Інші повторення',
  'tasks.comments': 'Коментарі',
  'tasks.addComment': 'Новий коментар',
  'tasks.commentPlaceholder': 'Напишіть коментар…',
  'tasks.commentHint': 'Ctrl/⌘ + Enter — надіслати',
  'tasks.send': 'Надіслати',
  'tasks.deleteTitle': 'Видалити завдання назавжди?',
  'tasks.deleteText': '«{title}» буде видалено разом із коментарями. Це не можна скасувати.',
  'tasks.deleteConfirm': 'Видалити завдання',
  'tasks.deleted': 'Завдання видалено',
  'tasks.emptyTitle': 'Завдань немає',
  'tasks.emptyText': 'Усе зроблено або фільтр надто вузький.',
  'board.moved': '«{title}» переміщено: {status}',
  'board.keyboardHelp': 'Enter — відкрити, стрілки вліво/вправо — перемістити в сусідню колонку. Мишею — перетягніть картку.',
  'board.addTo': 'Додати в «{status}»',
  'entity.client': 'Клієнт',
  'entity.pet': 'Тварина',
  'entity.visit': 'Візит',
  'entity.journey': 'Подорож візиту',
  'entity.call': 'Дзвінок',
  'entity.rating': 'Оцінка',
  'entity.insight': 'Інсайт',

  // series
  'series.new': 'Повторюване завдання',
  'series.create': 'Створити серію',
  'series.created': 'Серію створено',
  'series.description': 'Завдання створюватиметься автоматично за розкладом (час Києва, з урахуванням переходу на літній час).',
  'series.every': 'Кожні',
  'series.everyN': '{n}|{n}|{n}',
  'series.unit': 'Одиниця',
  'series.unit.minutes': 'Хвилини',
  'series.unit.hours': 'Години',
  'series.unit.days': 'Дні',
  'series.unit.weeks': 'Тижні',
  'series.unit.months': 'Місяці',
  'series.unit.years': 'Роки',
  'series.summary': 'Повторюється кожні {every} ({unit})',
  'series.startsAt': 'Перше виконання',
  'series.endsAt': 'Завершити',
  'series.endsHint': 'Порожньо — без кінця',
  'series.endsBeforeStart': 'Кінець раніше за початок',
  'series.requirePrevious': 'Лише після виконання попереднього',
  'series.requirePreviousHint': 'Наступне завдання з’явиться тільки коли попереднє позначено виконаним.',
  'series.requirePreviousShort': 'після виконання попереднього',
  'series.repeat': 'Повтор',
  'series.instances': 'Створено',
  'series.active': 'Активна',
  'series.stopped': 'Зупинена',
  'series.stop': 'Зупинити',
  'series.stopTitle': 'Зупинити серію?',
  'series.stopText': 'Нові завдання «{title}» більше не створюватимуться. Уже створені залишаться.',
  'series.stopConfirm': 'Зупинити серію',
  'series.stoppedToast': 'Серію зупинено',
  'series.emptyTitle': 'Повторюваних завдань ще немає',
  'series.emptyText': 'Наприклад: щопонеділка перевірити залишки вакцин.',

  // users & roles
  'users.subtitle': 'Запрошення персоналу, ролі та доступ',
  'users.invite': 'Запросити',
  'users.inviteTitle': 'Запросити співробітника',
  'users.inviteText': 'Співробітник отримає одноразове посилання (діє 72 години), щоб задати пароль.',
  'users.sendInvite': 'Створити запрошення',
  'users.fullName': 'Ім’я та прізвище',
  'users.name': 'Співробітник',
  'users.roles': 'Ролі',
  'users.status': 'Статус',
  'users.status.active': 'Активний',
  'users.status.invited': 'Запрошений',
  'users.status.disabled': 'Вимкнений',
  'users.mfaOn': '2FA увімкнено',
  'users.mfaOff': 'Без 2FA',
  'users.lastLogin': 'Останній вхід',
  'users.never': 'Ще не входив',
  'users.search': 'Пошук за ім’ям або email',
  'users.actionsFor': 'Дії для {name}',
  'users.employee': 'Працівник Enote',
  'users.doctor': 'Лікар',
  'users.notLinked': 'Не прив’язано',
  'users.linkEmployee': 'Прив’язати працівника Enote…',
  'users.changeEmployee': 'Змінити працівника Enote…',
  'users.employeeTitle': 'Працівник Enote для {name}',
  'users.employeeText': 'Від цього зв’язку залежить доступ лікаря: власні візити й записи з кабінету, черги «мої», перегляд аналізів і бриф перед візитом.',
  'users.employeeSearch': 'Пошук працівника',
  'users.employeeNone': 'Нікого не знайдено',
  'users.employeeLinkedTo': 'Прив’язано до {name}',
  'users.unlinkEmployee': 'Відв’язати',
  'users.employeeLinked': 'Працівника прив’язано',
  'users.employeeUnlinked': 'Працівника відв’язано',
  'users.employeeTaken': 'Цей акаунт уже прив’язано до іншого працівника.',
  'users.editRoles': 'Змінити ролі',
  'users.reinvite': 'Нове запрошення',
  'users.resetMfa': 'Скинути 2FA',
  'users.disable': 'Вимкнути',
  'users.enable': 'Увімкнути',
  'users.enabled': 'Обліковий запис увімкнено',
  'users.disabled': 'Обліковий запис вимкнено',
  'users.mfaReset': 'Двофакторну автентифікацію скинуто',
  'users.disableTitle': 'Вимкнути {name}?',
  'users.disableText': 'Усі сесії й токени користувача буде відкликано. Увімкнути знову можна будь-коли.',
  'users.resetMfaTitle': 'Скинути двофакторну автентифікацію?',
  'users.resetMfaText': '{name} зможе увійти лише з паролем і має знову налаштувати 2FA.',
  'users.pickRole': 'Оберіть щонайменше одну роль',
  'users.linkTitle': 'Запрошення створено',
  'users.linkText': 'Надішліть це посилання {email}. Воно діє 72 години і працює один раз.',
  'users.linkHint': 'Посилання показано лише зараз — скопіюйте його.',
  'users.rolesTitle': 'Ролі: {name}',
  'users.rolesSaved': 'Ролі збережено',
  'users.lastAdminTitle': 'Останній суперадміністратор',
  'role.super_admin': 'Суперадмін',
  'role.founder': 'Власниця',
  'role.admin': 'Адміністратор',
  'role.doctor': 'Лікар',
  'role.assistant': 'Асистент',
  'role.quality': 'Якість',
  'role.marketing': 'Маркетинг',
  'role.integrator': 'Інтегратор',
  'role.super_admin.desc': 'Усе, включно з користувачами, секретами й аудитом',
  'role.founder.desc': 'Читання всього, фінанси й звіти',
  'role.admin.desc': 'Розклад, клієнти, візити, повідомлення',
  'role.doctor.desc': 'Пацієнти, ШІ-рекомендації, підтвердження',
  'role.assistant.desc': 'Перегляд візитів і тварин, щоденник',
  'role.quality.desc': 'Дзвінки, оцінки, скарги',
  'role.marketing.desc': 'Сегменти й кампанії без транскриптів',
  'role.integrator.desc': 'Конектори, синхронізація, журнали',
  'role.call_center': 'Оператор колл-центра',
  'role.call_center.desc': 'Клієнти, дзвінки, записи, чати, задачі — без фінансів',
  'users.access': 'Доступ',
  'users.accessTitle': 'Доступ: {name}',
  'users.accessText': 'Ролі — це готові набори прав. Поверх них можна окремо дозволити або заборонити будь-яке право саме цьому співробітнику.',
  'users.accessRoles': 'Ролі',
  'users.accessPerms': 'Права',
  'users.accessHint': 'Швидкий старт — Оператор колл-центра: роль «Оператор колл-центра» (без фінансів і записів з кабінету).',
  'users.accessPreset': 'Застосувати',
  'users.accessPresetCallCenter': 'Оператор колл-центра',
  'users.accessPresetNoFinance': 'Без фінансів',
  'users.accessInherit': 'За роллю',
  'users.accessGrant': 'Дозволено',
  'users.accessDeny': 'Заборонено',
  'users.accessFromRoleOn': 'роль дає',
  'users.accessFromRoleOff': 'роль не дає',
  'users.accessReset': 'Скинути до ролі',
  'users.accessEffective': 'Діє зараз: {n} прав',
  'users.accessEffectiveOn': 'Діє',
  'users.accessEffectiveOff': 'Не діє',
  'users.accessSensitive': 'Чутливе',
  'users.accessPrivileged': 'Лише суперадмін може дозволити',
  'users.accessSaved': 'Доступ збережено',
  'users.accessSuperAdmin': 'Суперадміністратор завжди має всі права — окремі налаштування для нього недоступні.',
  'users.accessSelf': 'Власний доступ змінити не можна — попросіть іншого адміністратора.',
  'users.accessOverrides': 'Особливі права',
  'users.accessOverridesN': 'Особливих прав: {n}',
  'users.accessChanges': 'Змін прав: {n}',
  'journey.statCompleted': 'Завершено',
  'permGroup.clients': 'Клієнти й розклад',
  'permGroup.calls': 'Дзвінки',
  'permGroup.visits': 'Візити й подорожі',
  'permGroup.clinical': 'Клініка та ШІ',
  'permGroup.finance': 'Фінанси',
  'permGroup.tasks': 'Задачі й чати',
  'permGroup.marketing': 'Маркетинг і аналітика',
  'permGroup.inventory': 'Склад',
  'permGroup.admin': 'Адміністрування',
  'perm.clients.read': 'Картки клієнтів, тварин, візитів і розклад',
  'perm.clients.contact': 'Повні номери телефонів і повідомлення клієнтам',
  'perm.booking.manage': 'Заявки на запис з додатку',
  'perm.diary.write': 'Щоденник тварини',
  'perm.transcripts.call.read': 'Записи й розшифровки дзвінків',
  'perm.quality.manage': 'Опрацювання низьких оцінок',
  'perm.visits.journey.read': 'Подорожі візиту',
  'perm.links.correct': 'Виправлення зв’язків подорожей',
  'perm.transcripts.room.read': 'Записи з кабінету (власні візити)',
  'perm.transcripts.room.read_all': 'Записи з кабінету (усі візити)',
  'perm.ai.recommendation.generate': 'Чернетки ШІ-рекомендацій',
  'perm.ai.recommendation.approve': 'Підтвердження рекомендацій і аналізів',
  'perm.payments.read': 'Суми, оплати, баланси, чеки',
  'perm.finance.dashboard': 'Виручка й фінансові звіти',
  'perm.finance.configure': 'Налаштування ФОП',
  'perm.tasks.manage': 'Задачі',
  'perm.inbox.manage': 'Чати з клієнтами',
  'perm.marketing.manage': 'Сегменти й кампанії',
  'perm.marketing.export': 'Експорт контактів',
  'perm.analytics.read': 'Аналітика, KPI, інсайти',
  'perm.inventory.read': 'Склад і залишки',
  'perm.inventory.manage': 'Склад: пороги та типи складів',
  'perm.users.manage': 'Користувачі й доступ',
  'perm.settings.manage': 'Налаштування системи',
  'perm.connectors.configure': 'Конектори й секрети',
  'perm.sync.run': 'Запуск синхронізації',
  'perm.sync.view': 'Стан синхронізації',
  'perm.audit.read': 'Журнал аудиту',
  'perm.mcp.tokens.manage': 'API/MCP-токени',

  // connectors
  'connectors.subtitle': 'Зовнішні системи: стан, налаштування й перевірка з’єднання',
  'connectors.emptyTitle': 'Конекторів ще немає',
  'connectors.emptyText': 'Модулі інтеграцій (Enote, AI SIP, камери, Telegram…) ще не зареєстровані на сервері.',
  'connectors.lastSuccess': 'Остання успішна',
  'connectors.failures': 'Помилок поспіль',
  'connectors.secrets': 'Секрети',
  'connectors.rotated': 'Секрети змінено',
  'connectors.detail': 'Деталі',
  'connectors.configure': 'Налаштувати',
  'connectors.configureTitle': 'Налаштування: {name}',
  'connectors.configureText': 'Секрети зберігаються зашифрованими і ніколи не показуються повторно.',
  'connectors.test': 'Перевірити',
  'connectors.testOk': 'З’єднання працює',
  'connectors.testFail': 'Перевірка не пройшла — дивіться кроки',
  'connectors.lastTest': 'Остання перевірка',
  'connectors.noSteps': 'Кроків перевірки немає',
  'connectors.enabledLabel': 'Увімкнено',
  'connectors.enabledHint': 'Вимкнений конектор не синхронізує дані й не надсилає повідомлень.',
  'connectors.enabled': 'Конектор увімкнено',
  'connectors.disabled': 'Конектор вимкнено',
  'connectors.saved': 'Налаштування збережено',
  'connectors.secretSet': 'встановлено',
  'connectors.secretNotSet': 'не встановлено',
  'connectors.secretKeepHint': 'Залиште порожнім, щоб не змінювати',
  'connectors.clear': 'Очистити',
  'connectors.keep': 'Не очищати',
  'connectors.noFields': 'Цей конектор не має налаштувань.',
  'health.ok': 'Працює',
  'health.degraded': 'Збої',
  'health.down': 'Недоступний',
  'health.auth_error': 'Помилка доступу',
  'health.disabled': 'Вимкнено',
  'health.unknown': 'Невідомо',

  // sync
  'sync.subtitle': 'Інкрементальна синхронізація сутностей, історія запусків і черга помилок',
  'sync.entities': 'Сутності',
  'sync.runs': 'Запуски',
  'sync.errors': 'Помилки',
  'sync.entity': 'Сутність',
  'sync.enabled': 'Увімк.',
  'sync.enabledFor': 'Синхронізація {entity}',
  'sync.interval': 'Інтервал',
  'sync.intervalMinutes': 'Інтервал, хвилин',
  'sync.editInterval': 'Змінити інтервал',
  'sync.min': 'хв',
  'sync.lastRun': 'Останній запуск',
  'sync.lag': 'Відставання',
  'sync.counters': 'Лічильники',
  'sync.lastError': 'Помилка',
  'sync.runNow': 'Запустити',
  'sync.runAll': 'Запустити все',
  'sync.full': 'Повна',
  'sync.fullHint': 'Перезавантажити всю історію (може тривати години)',
  'sync.fullTitle': 'Повна пересинхронізація «{entity}»?',
  'sync.fullText': 'Уся історія буде завантажена заново. Це може тривати години й навантажити зовнішню систему.',
  'sync.fullConfirm': 'Запустити повну',
  'sync.reconcile': 'Звірка',
  'sync.enqueued': 'Запуск «{entity}» поставлено в чергу',
  'sync.enqueuedMany': 'У черзі: {n}',
  'sync.emptyTitle': 'Немає сутностей для синхронізації',
  'sync.emptyText': 'Вони з’являться, коли будуть підключені модулі інтеграцій.',
  'sync.noRuns': 'Запусків ще не було',
  'sync.started': 'Початок',
  'sync.mode': 'Режим',
  'sync.duration': 'Тривалість',
  'sync.noErrors': 'Помилок немає',
  'sync.noErrorsText': 'Усі записи синхронізовано без проблем.',
  'sync.when': 'Коли',
  'sync.record': 'Запис',
  'sync.message': 'Повідомлення',
  'sync.retries': 'Спроб',
  'sync.retry': 'Повторити',
  'sync.retried': 'Повторну синхронізацію заплановано',
  'sync.deadLetter': 'Відкласти',
  'sync.deadLettered': 'Запис переміщено у відкладені',

  // jobs / settings / audit / system
  'jobs.subtitle': 'Черги фонових задач (оновлюється кожні 10 с)',
  'jobs.kind': 'Тип',
  'jobs.available': 'У черзі',
  'jobs.running': 'Виконуються',
  'jobs.failed': 'Невдалі',
  'jobs.failedHint': 'Потрібна увага',
  'jobs.completed': 'Виконано за 24 год',
  'jobs.empty': 'Фонових задач ще немає',
  'settings.subtitle': 'Параметри продукту у форматі JSON: правила, нагадування, тихі години, налаштування ШІ',
  'settings.add': 'Новий параметр',
  'settings.empty': 'Налаштувань ще немає',
  'settings.emptyText': 'Додайте перший параметр — наприклад, тихі години для сповіщень.',
  'settings.search': 'Фільтр за ключем',
  'settings.unsaved': 'не збережено',
  'settings.revert': 'Відмінити',
  'settings.saved': 'Параметр {key} збережено',
  'settings.invalidJson': 'Некоректний JSON',
  'settings.key': 'Ключ',
  'settings.keyInvalid': 'Лише латиниця, цифри, крапка, дефіс і підкреслення',
  'settings.value': 'Значення (JSON)',
  'audit.subtitle': 'Незмінний журнал: хто, що і коли зробив',
  'audit.filters': 'Фільтри журналу',
  'audit.action': 'Дія (префікс)',
  'audit.actor': 'Виконавець',
  'audit.entity': 'Об’єкт',
  'audit.entityId': 'ID об’єкта',
  'audit.when': 'Коли',
  'audit.via': 'Канал',
  'audit.result': 'Результат',
  'audit.details': 'Деталі',
  'audit.empty': 'Записів не знайдено',
  'audit.more': 'Завантаження…',
  'audit.end': 'Кінець журналу · {n} записів',
  'system.subtitle': 'Конектори, відставання синхронізації та черги задач',
  'system.dbOk': 'База даних доступна',
  'system.dbDown': 'База недоступна',
  'system.connectors': 'Конектори',
  'system.sync': 'Синхронізація',
  'system.jobs': 'Фонові задачі',
  'system.needAttention': 'Потребують уваги: {n}',
  'system.allHealthy': 'Усі працюють',
  'system.lagging': 'Відстають: {n}',
  'system.syncOk': 'Без відставання',
  'system.jobsFailed': 'Невдалих: {n}',
  'system.jobsOk': 'Без помилок',
  'system.syncLag': 'Відставання синхронізації',

  // mappings / client app
  'rooms.subtitle': 'Камери Dovira Cameras, їх кабінети та сесії прийомів',
  'rooms.empty': 'Кабінетів ще немає',
  'rooms.emptyText': 'Кабінети з’являться після синхронізації з Enote.',
  'rooms.mapped': 'Камера є',
  'rooms.unmapped': 'Без камери',
  'rooms.noCamera': 'До «{room}» не прив’язано камеру — прив’яжіть її',
  'rooms.noThumb': 'Немає кадру',
  'rooms.thumbAlt': 'Останній кадр камери в кабінеті {room}',
  'rooms.now': 'дотепер',
  'rooms.map': 'Прив’язати камеру',
  'rooms.unmap': 'Відв’язати',
  'rooms.mapTitle': 'Камера для «{room}»',
  'rooms.camera': 'Камера',
  'rooms.noCameras': 'Камер немає',
  'rooms.validFrom': 'Діє з',
  'rooms.validTo': 'Діє до',
  'rooms.validToHint': 'Порожньо — безстроково',
  'rooms.mappedToast': 'Камеру прив’язано',
  'operators.subtitle': 'Оператори AI SIP ↔ співробітники Enote ↔ користувачі Bridge',
  'operators.search': 'Пошук оператора',
  'operators.unmapped': 'Без співробітника: {n}',
  'operators.empty': 'Операторів не знайдено',
  'operators.operator': 'Оператор AI SIP',
  'operators.employee': 'Співробітник Enote',
  'operators.user': 'Користувач Bridge',
  'operators.employeeFor': 'Співробітник для {name}',
  'operators.userFor': 'Користувач для {name}',
  'operators.saved': 'Прив’язку збережено',
  'clientapp.subtitle': 'Заявки на запис і облікові записи клієнтів у застосунку',
  'clientapp.requests': 'Заявки на запис',
  'clientapp.accounts': 'Облікові записи',
  'clientapp.noRequests': 'Нових заявок немає',
  'clientapp.wants': 'Бажаний час: {when}',
  'clientapp.anyTime': 'Будь-який час',
  'clientapp.confirm': 'Підтвердити',
  'clientapp.reject': 'Відхилити',
  'clientapp.confirmTitle': 'Підтвердити запис: {name}',
  'clientapp.confirmText': 'Запис буде створено в Enote, клієнт отримає сповіщення.',
  'clientapp.confirmed': 'Запис підтверджено',
  'clientapp.rejectTitle': 'Відхилити заявку',
  'clientapp.rejected': 'Заявку відхилено',
  'clientapp.reason': 'Причина',
  'clientapp.reasonHint': 'Клієнт побачить цей текст',
  'clientapp.time': 'Час візиту',
  'clientapp.searchAccounts': 'Пошук за телефоном або ім’ям',
  'clientapp.typeToSearch': 'Введіть щонайменше 2 символи',
  'clientapp.account': 'Обліковий запис',
  'clientapp.client': 'Клієнт',
  'clientapp.platform': 'Платформа',
  'clientapp.lastSeen': 'Остання активність',
  'clientapp.verified': 'підтверджено',

  // profile
  'profile.subtitle': 'Особисті дані, безпека, токени доступу й сповіщення',
  'profile.tab.me': 'Про мене',
  'profile.tab.security': 'Безпека',
  'profile.tab.tokens': 'API та MCP',
  'profile.tab.notifications': 'Сповіщення',
  'profile.mfa': 'Двофакторна автентифікація',
  'profile.permissions': 'Дозволи',
  'profile.changePassword': 'Змінити пароль',
  'profile.changePasswordText': 'Після зміни інші сесії залишаться активними — за потреби завершіть їх нижче.',
  'profile.currentPassword': 'Поточний пароль',
  'profile.newPassword': 'Новий пароль',
  'profile.passwordChanged': 'Пароль змінено',
  'profile.passwordSame': 'Новий пароль має відрізнятися від поточного',
  'profile.totp': 'Двофакторна автентифікація',
  'profile.totpText': 'Код із застосунку (Google Authenticator, 1Password, Authy) при кожному вході.',
  'profile.totpStart': 'Налаштувати 2FA',
  'profile.totpRestart': 'Перевипустити ключ',
  'profile.totpReconfigure': '2FA уже працює. Можна перевипустити ключ, наприклад, для нового телефона.',
  'profile.totpStep1': 'Скануйте QR-код застосунком автентифікації або введіть ключ вручну.',
  'profile.totpStep2': 'Введіть 6-значний код, щоб підтвердити.',
  'profile.totpConfirm': 'Увімкнути 2FA',
  'profile.totpEnabled': 'Двофакторну автентифікацію увімкнено',
  'profile.qrAlt': 'QR-код для застосунку автентифікації',
  'profile.sessions': 'Активні сесії',
  'profile.sessionsText': 'Пристрої, з яких виконано вхід.',
  'profile.thisDevice': 'цей пристрій',
  'profile.lastSeen': 'активність {when}',
  'profile.expires': 'діє до {when}',
  'profile.revoke': 'Відкликати',
  'profile.sessionRevoked': 'Сесію завершено',
  'tokens.title': 'Токени API та MCP',
  'tokens.text': 'Для Claude (Desktop, Code, claude.ai) і скриптів. Токен діє з вашими правами або вужче.',
  'tokens.create': 'Створити токен',
  'tokens.createText': 'Оберіть назву, строк дії та інструменти, доступні через токен.',
  'tokens.empty': 'Токенів ще немає',
  'tokens.emptyText': 'Створіть токен, щоб підключити Claude до Bridge через MCP.',
  'tokens.name': 'Назва',
  'tokens.nameHint': 'Наприклад: «Claude Desktop — ноутбук»',
  'tokens.ttl': 'Строк дії',
  'tokens.days': '{n} днів',
  'tokens.noExpiry': 'Безстроково',
  'tokens.tools': 'Дозволені інструменти',
  'tokens.filterTools': 'Фільтр інструментів',
  'tokens.readOnly': 'Лише читання',
  'tokens.allTools': 'Усі інструменти',
  'tokens.allToolsHint': 'Нічого не обрано — токен матиме всі інструменти, доступні вашій ролі.',
  'tokens.selectedN': 'Обрано інструментів: {n}',
  'tokens.toolsN': 'інструментів: {n}',
  'tokens.used': 'використано {when}',
  'tokens.neverUsed': 'ще не використовувався',
  'tokens.expires': 'діє до {when}',
  'tokens.revoke': 'Відкликати токен',
  'tokens.revokeTitle': 'Відкликати «{name}»?',
  'tokens.revokeText': 'Усі клієнти, що використовують цей токен, одразу втратять доступ.',
  'tokens.revoked': 'Токен відкликано',
  'tokens.createdTitle': 'Токен «{name}» створено',
  'tokens.onceWarning': 'Скопіюйте токен зараз — більше його не буде показано.',
  'tokens.savedIt': 'Я зберіг токен',
  'tokens.howTo': 'Як підключити',
  'tokens.howCode': 'Виконайте в терміналі:',
  'tokens.howDesktop': 'Додайте до claude_desktop_config.json і перезапустіть Claude Desktop:',
  'tokens.howWeb': 'У claude.ai → Налаштування → Конектори додайте власний конектор з цією адресою (вхід через OAuth, токен не потрібен):',
  'tokens.howStdio': 'Локально на сервері (stdio):',
  'prefs.title': 'Сповіщення про завдання',
  'prefs.text': 'Коли і куди надсилати сповіщення.',
  'prefs.assign': 'Мені призначили завдання',
  'prefs.assignHint': 'Одразу після призначення',
  'prefs.comment': 'Коментар у моєму завданні',
  'prefs.commentHint': 'Якщо я виконавець або спостерігач',
  'prefs.creatorComment': 'Коментар у створеному мною завданні',
  'prefs.creatorCommentHint': 'Якщо я автор завдання',
  'prefs.due': 'Нагадування про термін',
  'prefs.dueHint': 'Один раз перед терміном',
  'prefs.leadHours': 'За скільки годин нагадати',
  'prefs.leadHoursHint': 'Від 1 до 168 годин',
  'prefs.leadHoursErr': 'Вкажіть від 1 до 168',
  'prefs.channels': 'Канали',
  'prefs.ch.inbox': 'У застосунку',
  'prefs.ch.telegram': 'Telegram',
  'prefs.ch.email': 'Email',
  'prefs.ch.push': 'Push',
  'prefs.saved': 'Налаштування сповіщень збережено',
  'prefs.telegramText': 'Отримуйте сповіщення в Telegram-боті клініки.',
  'prefs.pairTelegram': 'Під’єднати Telegram',
  'prefs.openTelegram': 'Відкрити Telegram',
  'prefs.telegramHint': 'Натисніть «Start» у боті, щоб завершити під’єднання. Посилання діє 10 хвилин.',

  // today
  'today.night': 'Доброї ночі',
  'today.morning': 'Доброго ранку',
  'today.afternoon': 'Добрий день',
  'today.evening': 'Добрий вечір',
  'today.dashboard': 'Панель',
  'today.variant.admin': 'Адміністратор',
  'today.variant.doctor': 'Лікар',
  'today.variant.founder': 'Власниця',
  'today.appointments': 'Записи на сьогодні',
  'today.noAppointments': 'Сьогодні записів немає',
  'today.late': 'Запізнюються',
  'today.noLate': 'Усі вчасно',
  'today.unbooked': 'Дзвінки без запису (24 год)',
  'today.noUnbooked': 'Усіх, хто дзвонив, записано',
  'today.callback': 'Передзвонити',
  'today.callbackTitle': 'Передзвонити: {who}',
  'today.callbackCreated': 'Завдання «передзвонити» створено',
  'today.labsUndelivered': 'Аналізи чекають перегляду',
  'today.labsReview': 'Аналізи на перегляд',
  'today.noLabs': 'Нових результатів немає',
  'today.abnormal': 'поза нормою: {n}',
  'today.lowRatings': 'Низькі оцінки',
  'today.noFollowups': 'Незадоволених клієнтів немає',
  'today.unpaid': 'Вчора: без оплати / чека',
  'today.noFlags': 'Розбіжностей немає',
  'today.bookingRequests': 'Заявки на запис',
  'today.myTasks': 'Мої завдання',
  'today.noTasks': 'Відкритих завдань немає',
  'today.nextPatients': 'Наступні пацієнти',
  'today.noPatients': 'Пацієнтів на сьогодні немає',
  'today.drafts': 'Чернетки на підтвердження',
  'today.noDrafts': 'Усі рекомендації підтверджено',
  'today.oldestDraft': 'Найстаріша: {when}',
  'today.period': 'Період',
  'today.vsPrev': 'до попер.',
  'today.noCompare': 'немає порівняння',
  'period.today': 'Сьогодні',
  'period.week': 'Тиждень',
  'period.month': 'Місяць',
  'kpi.revenue': 'Виручка',
  'kpi.visits': 'Візити',
  'kpi.avgCheck': 'Середній чек',
  'kpi.newClients': 'Нові клієнти',
  'kpi.noShow': 'Неявки',
  'kpi.conversion': 'Конверсія в запис',
  'kpi.revenueTrend': 'Виручка по днях',
  'kpi.current': 'Поточний період',
  'kpi.previous': 'Попередній період',
  'kpi.byFop': 'Виручка по ФОП',
  'kpi.funnel': 'Конверсія',
  'kpi.calls': 'Дзвінки',
  'kpi.bookings': 'Записи',
  'kpi.visitsDone': 'Візити',
  'kpi.doctorLoad': 'Завантаження лікарів',
  'appt.booked': 'Записаний',
  'appt.confirmed': 'Підтверджено',
  'appt.arrived': 'Прийшов',
  'appt.in_room': 'У кабінеті',
  'appt.done': 'Завершено',
  'appt.no_show': 'Не прийшов',
  'appt.cancelled': 'Скасовано',

  // schedule
  'schedule.date': 'Дата',
  'schedule.day': 'День',
  'schedule.week': 'Тиждень',
  'schedule.byDoctor': 'За лікарями',
  'schedule.byRoom': 'За кабінетами',
  'schedule.empty': 'На цей період записів немає',
  'schedule.unassigned': 'Без призначення',
  'schedule.client': 'Клієнт',
  'schedule.pet': 'Тварина',
  'schedule.doctor': 'Лікар',
  'schedule.room': 'Кабінет',
  'schedule.time': 'Час',
  'schedule.reason': 'Причина',
  'schedule.openJourney': 'Відкрити візит',

  // journeys
  'journey.subtitle': 'Подорож кожного візиту: дзвінок → запис → кабінет → лікування → оплата → рекомендації → оцінка',
  'journey.search': 'Пошук за кличкою чи клієнтом',
  'journey.missingLinks': 'Без зв’язків',
  'journey.visit': 'Візит',
  'journey.patient': 'Пацієнт',
  'journey.stages': 'Етапи',
  'journey.flags': 'Позначки',
  'journey.rating': 'Оцінка',
  'journey.pendingLinks': 'на перевірку: {n}',
  'journey.timeline': 'Хронологія',
  'journey.context': 'Клієнт і тварина',
  'journey.date': 'Дата',
  'journey.generate': 'Згенерувати рекомендації',
  'journey.draftRequested': 'Генерацію чернетки запущено',
  'journey.message': 'Написати клієнту',
  'journey.createTask': 'Створити завдання',
  'stage.call': 'Дзвінок',
  'stage.booking': 'Запис',
  'stage.arrival': 'Прибуття',
  'stage.room': 'Кабінет',
  'stage.clinical': 'Лікування',
  'stage.invoice': 'Рахунок',
  'stage.payment': 'Оплата',
  'stage.recommendations': 'Рекомендації',
  'stage.rating': 'Оцінка',
  'stage.followup': 'Контроль',
  'stage.state.ok': 'виконано',
  'stage.state.warn': 'потребує уваги',
  'stage.state.none': 'немає даних',
  'stage.state.na': 'не застосовно',
  'link.auto': 'авто',
  'link.proposed': 'пропозиція',
  'link.manual': 'вручну',
  'link.confirmed': 'підтверджено',
  'link.rejected': 'відхилено',
  'link.confirm': 'Підтвердити',
  'link.reject': 'Відхилити',
  'link.replace': 'Замінити',
  'link.confirmedToast': 'Зв’язок підтверджено',
  'link.rejectedToast': 'Зв’язок відхилено',
  'link.replacedToast': 'Зв’язок замінено',
  'link.replaceTitle': 'Замінити зв’язок',
  'link.replaceText': 'Вкажіть правильний об’єкт ({kind}).',
  'link.targetId': 'ID об’єкта',
  'link.targetHint': 'Скопіюйте ID дзвінка або сесії з відповідної сторінки',
  'review.subtitle': 'Запропоновані зв’язки за часом візиту.',
  'review.nav': 'навігація',
  'review.queue': 'Черга зв’язків',
  'review.empty': 'Черга порожня',
  'review.emptyText': 'Усі запропоновані зв’язки перевірено.',
  'review.kind.call': 'Дзвінок',
  'review.kind.room': 'Сесія в кабінеті',
  'review.proposed': 'Запропоновано',
  'review.alternative': 'Альтернатива',
  'review.useThis': 'Обрати цей',
  'review.evidence': 'Докази',
  'review.excerpt': 'Фрагмент транскрипту',
  'review.split': 'Розділити сесію',
  'review.splitText': 'Якщо в записі два візити поспіль — перетягніть межу на місце зміни пацієнта.',
  'review.splitAt': 'Межа',
  'review.splitButton': 'Розділити',
  'review.splitDone': 'Сесію розділено',

  // clients & pets
  'clients.subtitle': 'Усі клієнти клініки; пошук за ім’ям, телефоном або кличкою',
  'clients.searchPlaceholder': 'Ім’я, телефон або кличка…',
  'clients.hintTitle': 'Кого шукаємо?',
  'clients.hintText': 'Спробуйте частину імені, телефону або клички.',
  'clients.lastVisit': 'Останній візит: {date}',
  'clients.lastVisitLabel': 'Останній візит',
  'clients.app': 'Застосунок',
  'clients.phones': 'Телефони',
  'clients.balance': 'Баланс',
  'clients.visits': 'Візитів',
  'clients.since': 'Клієнт з',
  'clients.pets': 'Тварини',
  'clients.deceased': 'помер',
  'timeline.empty': 'Подій ще немає',
  'pet.species': 'Вид / порода',
  'pet.sex': 'Стать',
  'pet.age': 'Вік',
  'pet.ageValue': '{y} р. {m} міс.',
  'pet.birth': 'Дата народження',
  'pet.weight': 'Вага',
  'pet.chip': 'Чип',
  'pet.labs': 'Аналізи',
  'pet.profile': 'Профіль',
  'pet.latest': 'Останні значення',
  'pet.noLabs': 'Аналізів ще немає',
  'pet.bandHint': 'Зелена смуга — референтний діапазон; червоні точки — поза нормою.',
  'pet.vaccinations': 'Щеплення',
  'pet.weightTrend': 'Динаміка ваги',
  'lab.normal': 'норма',
  'lab.high': 'вище норми',
  'lab.low': 'нижче норми',

  // doctor
  'doctor.subtitle': 'Мої пацієнти, брифи перед прийомом і чернетки рекомендацій',
  'doctor.drafts': 'Чернетки ШІ',
  'doctor.myVisits': 'Мої візити сьогодні',
  'doctor.briefs': 'Найближчі пацієнти',
  'doctor.allergies': 'Алергії',
  'doctor.phoneNotes': 'Зі слів по телефону',
  'doctor.lastLabs': 'Останні аналізи',
  'draft.transcript': 'Транскрипт',
  'draft.editor': 'Рекомендації для клієнта',
  'draft.summary': 'Підсумок для клієнта',
  'draft.diagnosis': 'Діагноз',
  'draft.treatment': 'Лікування',
  'draft.recommendations': 'Рекомендації',
  'draft.follow_up': 'Контроль',
  'draft.medications': 'Препарати',
  'draft.medName': 'Препарат',
  'draft.dose': 'Доза',
  'draft.schedule': 'Схема',
  'draft.reminder': 'Нагадування клієнту',
  'draft.reminderHint': 'Клієнт отримає нагадування про прийом',
  'draft.addMed': 'Додати препарат',
  'draft.approve': 'Підтвердити й надіслати',
  'draft.approved': 'Рекомендації надіслано клієнту',
  'draft.saved': 'Рекомендації збережено',
  'draft.reject': 'Відхилити',
  'draft.rejectTitle': 'Відхилити рекомендації',
  'draft.rejected': 'Рекомендації відхилено',
  'draft.regenerate': 'Перегенерувати',
  'draft.regenText': 'Підкажіть ШІ, що змінити.',
  'draft.note': 'Примітка',
  'draft.noteHint': 'Наприклад: «коротше, без латини»',
  'draft.changed': 'змінено розділів: {n}',
  'draft.edited': 'змінено',
  'draft.citations': 'джерел: {n}',
  'draft.createdBy': 'джерело: {source}',
  'transcript.empty': 'Транскрипту немає',
  'transcript.search': 'Пошук у транскрипті',
  'transcript.matches': 'збігів: {n}',
  'transcript.seek': 'Перейти до {t}',
  'transcript.doctor': 'лікар',
  'transcript.client': 'клієнт',
  'transcript.assistant': 'асистент',
  'transcript.operator': 'оператор',

  // calls
  'calls.subtitle': 'Дзвінки з AI SIP: транскрипти, оцінки, зв’язки з візитами',
  'calls.when': 'Коли',
  'calls.who': 'Хто',
  'calls.unknown': 'Невідомий номер',
  'calls.operator': 'Оператор',
  'calls.duration': 'Тривалість',
  'calls.score': 'Оцінка',
  'calls.risk': 'Ризик',
  'calls.risk.low': 'низький',
  'calls.risk.medium': 'середній',
  'calls.risk.high': 'високий',
  'calls.flags': 'Позначки',
  'calls.intent': 'Хотів записатися',
  'calls.linked': 'Пов’язано',
  'calls.unlinked': 'Без зв’язку',
  'calls.linkedFilter': 'Зв’язок',
  'calls.from': 'З',
  'calls.to': 'По',
  'calls.direction': 'Напрямок',
  'calls.inbound': 'Вхідний',
  'calls.outbound': 'Вихідний',
  'calls.status': 'Статус',
  'calls.answered': 'Прийнятий',
  'calls.missedStatus': 'Пропущений',
  'calls.search': 'Пошук за номером чи іменем',
  'calls.analysis': 'Аналіз дзвінка',
  'calls.requiredActions': 'Потрібні дії',
  'calls.links': 'Зв’язки',
  'calls.noLinks': 'Дзвінок ще не пов’язано з візитом',
  'missed.subtitle': 'Вхідні дзвінки з наміром записатися, після яких запису не було протягом 24 годин',
  'missed.emptyText': 'Втрачених можливостей немає.',
  'missed.intent': 'намір {p}',
  'missed.callbackTask': 'Завдання «передзвонити»',

  // inbox
  'inbox.subtitle': 'Чат із клієнтами (застосунок і Telegram)',
  'inbox.empty': 'Відкритих розмов немає',
  'inbox.conversations': 'Розмови',
  'inbox.close': 'Закрити розмову',
  'inbox.message': 'Повідомлення',
  'inbox.placeholder': 'Відповідь клієнту… (Enter — надіслати, Shift+Enter — новий рядок)',

  // finance
  'finance.subtitle': 'Звірка оплат і чеків по ФОП, розбіжності та виручка',
  'finance.revenue': 'Виручка по ФОП',
  'finance.other': 'Інші',
  'finance.reconciliation': 'Звірка: день × ФОП',
  'finance.date': 'Дата',
  'finance.fop': 'ФОП',
  'finance.sales': 'Продажі',
  'finance.receipts': 'Чеки',
  'finance.discrepancy': 'Розбіжність',
  'finance.flags': 'Позначені візити',
  'finance.flagKind': 'Тип розбіжності',
  'finance.amount': 'Сума',
  'finance.expected': 'очікувалось',
  'finance.flag.no_receipt': 'Без фіскального чека',
  'finance.flag.amount_mismatch': 'Сума чека не збігається',
  'finance.flag.fop_mismatch': 'Чек на іншого ФОП',
  'finance.flag.unpaid': 'Не оплачено',

  // quality
  'quality.subtitle': 'Оцінки візитів і робота з незадоволеними клієнтами (30 днів)',
  'quality.summary': 'Оцінки',
  'quality.avg': 'Середня',
  'quality.count': 'оцінок: {n}',
  'quality.distribution': 'Розподіл оцінок',
  'quality.followups': 'Потрібна реакція',
  'quality.resolve': 'Закрити',
  'quality.resolveTitle': 'Реакція на оцінку: {name}',
  'quality.resolution': 'Що зроблено',
  'quality.resolutionHint': 'Наприклад: зателефонували, запропонували повторний огляд',
  'quality.resolved': 'Звернення закрито',

  // marketing
  'marketing.subtitle': 'Сегменти клієнтів і кампанії з урахуванням згоди на розсилки',
  'marketing.segments': 'Сегменти',
  'marketing.campaigns': 'Кампанії',
  'marketing.newSegment': 'Новий сегмент',
  'marketing.editSegment': 'Сегмент',
  'marketing.noSegments': 'Сегментів ще немає',
  'marketing.pickSegment': 'Оберіть сегмент або створіть новий',
  'marketing.rulesN': 'умов: {n}',
  'marketing.liveCount': 'Клієнтів',
  'marketing.segmentName': 'Назва сегмента',
  'marketing.rules': 'Умови',
  'marketing.addRule': 'Додати умову',
  'marketing.field': 'Поле',
  'marketing.op': 'Оператор',
  'marketing.value': 'Значення',
  'marketing.saved': 'Сегмент збережено',
  'marketing.f.species': 'Вид тварини',
  'marketing.f.age_years': 'Вік тварини, р.',
  'marketing.f.last_visit_days': 'Днів від візиту',
  'marketing.f.vaccination_due': 'Щеплення',
  'marketing.f.spend_12m': 'Витрати, ₴',
  'marketing.f.rating': 'Середня оцінка',
  'marketing.f.channel': 'Канал зв’язку',
  'marketing.op.eq': 'дорівнює',
  'marketing.op.neq': 'не дорівнює',
  'marketing.op.gte': '≥',
  'marketing.op.lte': '≤',
  'marketing.newCampaign': 'Нова кампанія',
  'marketing.noCampaigns': 'Кампаній ще немає',
  'marketing.campaign': 'Кампанія',
  'marketing.segment': 'Сегмент',
  'marketing.channel': 'Канал',
  'marketing.scheduled': 'Запланована',
  'marketing.sent': 'Надіслано',
  'marketing.delivered': 'Доставлено',
  'marketing.bookings': 'Записи',
  'marketing.text': 'Текст повідомлення',
  'marketing.textHint': 'Символів: {n}',
  'marketing.scheduleHint': 'Порожньо — чернетка',
  'marketing.consentNote': 'Повідомлення отримають лише клієнти зі згодою; відписка додається автоматично.',
  'marketing.create': 'Створити кампанію',
  'marketing.created': 'Кампанію створено',

  // insights
  'insights.subtitle': 'Висновки регулярних аналізів Claude — перетворюйте їх на завдання',
  'insights.new': 'Нові',
  'insights.converted': 'У завданнях',
  'insights.dismissed': 'Приховані',
  'insights.empty': 'Нових інсайтів немає',
  'insights.emptyText': 'Claude публікує інсайти після щоденних і щотижневих аналізів.',
  'insights.toTask': 'Створити завдання',
  'insights.taskCreated': 'Завдання створено',
  'insights.dismiss': 'Приховати',
  'insights.openTask': 'Відкрити завдання →',
  'insights.sev.info': 'інфо',
  'insights.sev.warning': 'увага',
  'insights.sev.critical': 'критично',
  'table.pageN': 'Сторінка {page}',
  'table.pageTotal': 'Сторінка {page} · усього {total}',
  'filters.reset': 'Скинути',
  'filters.from': 'з',
  'filters.to': 'по',
  'stage.confirmation_call': 'Підтвердження',
  'stage.room_session': 'Кабінет',
  'stage.diagnoses': 'Діагнози',
  'stage.labs': 'Аналізи',
  'stage.prescriptions': 'Призначення',
  'stage.vaccinations': 'Вакцинації',
  'stage.sale': 'Рахунок',
  'stage.receipt': 'Фіскальний чек',
  'stage.recommendation': 'Рекомендації',
  'stage.follow_up': 'Контроль',
  'stage.followup_call': 'Дзвінок після',
  'stage.state.present': 'є',
  'stage.state.proposed': 'на перевірку',
  'stage.state.missing': 'бракує',
  'stage.state.not_applicable': 'не потрібно',
  'ev.iou': 'Збіг у часі (IoU)',
  'ev.pet_mentioned': 'Названо кличку',
  'ev.species_mentioned': 'Названо вид',
  'ev.doctor_mentioned': 'Названо лікаря',
  'ev.doctor_voice': 'Голос лікаря',
  'ev.client_surname': 'Прізвище клієнта',
  'ev.clinical_mentioned': 'Клінічні терміни',
  'ev.room_exact': 'Той самий кабінет',
  'ev.dept_fallback': 'Лише відділення',
  'ev.ambiguity': 'Конкуренція',
  'ev.phone_match': 'Збіг телефону',
  'ev.time_proximity': 'Близькість у часі',
  'ev.rule': 'Правило',
  'ev.logit': 'Логіт',
  'ev.low_signal': 'Мало мовлення',
  'ev.no_auto': 'Без автопідтвердження',
  'ev.phone_client': 'Телефон клієнта',
  'ev.phone_appointment': 'Телефон із запису',
  'ev.phone_household': 'Телефон родини',
  'ev.ended_before_created': 'Дзвінок перед записом',
  'ev.operator_is_author': 'Оператор створив запис',
  'ev.booking_intent': 'Намір записатися',
  'ev.confirm_window': 'Вікно підтвердження',
  'ev.followup_window': 'Вікно після візиту',
  'fact.amount': 'Сума',
  'fact.paid_amount': 'Сплачено',
  'fact.total_amount': 'Разом',
  'fact.fop': 'ФОП',
  'fact.method': 'Спосіб',
  'fact.number': '№',
  'fact.fiscal_number': 'Фіск. №',
  'fact.status': 'Статус',
  'fact.camera': 'Камера',
  'fact.room': 'Кабінет',
  'fact.speech_seconds': 'Мовлення',
  'fact.low_signal': 'Мало мовлення',
  'fact.confirmed': 'Підтверджено',
  'fact.duration_min': 'Тривалість, хв',
  'fact.duration_s': 'Тривалість',
  'fact.diagnosis': 'Діагноз',
  'fact.visit_type': 'Тип візиту',
  'fact.doc_type': 'Документ',
  'fact.is_return': 'Повернення',
  'fact.direction': 'Напрям',
  'fact.operator': 'Оператор',
  'fact.score': 'Оцінка',
  'fact.stars': 'Зірки',
  'journey.openCall': 'Відкрити дзвінок',
  'journey.openTranscript': 'Відкрити транскрипт',
  'journey.recommendation': 'Рекомендації',
  'journey.pendingHint': 'Підтвердіть або відхиліть пропозиції в хронології нижче.',
  'journey.noTimeline': 'Подій ще немає',
  'journey.planned': 'Запланований час',
  'journey.started': 'Фактично',
  'journey.nextVisit': 'Наступний візит',
  'journey.links': 'Зв’язки',
  'journey.state': 'Стан',
  'journey.allStates': 'Усі стани',
  'journey.allFlags': 'Усі позначки',
  'journey.oneClient': 'Один клієнт',
  'journey.empty': 'Подорожей за період немає',
  'journey.emptyHint': 'Змініть період або фільтри.',
  'journey.statTotal': 'Подорожей',
  'journey.statPaid': 'Оплачено',
  'journey.statBookingCall': 'Записи з дзвінком',
  'journey.statRoom': 'Візити з транскриптом',
  'journey.statMissed': 'Втрачені звернення',
  'anchor.appointment': 'за записом',
  'anchor.walk_in': 'без запису',
  'anchor.call_only': 'лише дзвінок',
  'anchor.visit': 'візит',
  'jstate.planned': 'Заплановано',
  'jstate.called_not_booked': 'Дзвонив, не записався',
  'jstate.booked': 'Записаний',
  'jstate.arrived': 'Прийшов',
  'jstate.in_room': 'У кабінеті',
  'jstate.completed': 'Прийом завершено',
  'jstate.paid': 'Оплачено',
  'jstate.closed': 'Закрито',
  'jstate.no_show': 'Не прийшов',
  'jstate.cancelled': 'Скасовано',
  'jflag.missing_recommendation': 'Немає рекомендацій',
  'jflag.ai_draft_pending': 'Чернетка ШІ чекає',
  'jflag.unlinked_transcript': 'Транскрипт не прив’язано',
  'jflag.unlinked_call': 'Дзвінок не прив’язано',
  'jflag.unpaid': 'Не оплачено',
  'jflag.partially_paid': 'Частково оплачено',
  'jflag.no_receipt': 'Немає чека',
  'jflag.amount_mismatch': 'Розбіжність суми',
  'jflag.fop_mismatch': 'Не той ФОП',
  'jflag.low_rating': 'Низька оцінка',
  'review.type': 'Тип об’єкта',
  'review.allTypes': 'Усі типи',
  'review.candidates': 'варіантів: {n}',
  'transcript.unknown': 'невідомо',
  'transcript.roles': 'Ролі мовців',
  'appt.scheduled': 'Записаний',
  'appt.in_progress': 'На прийомі',
  'appt.completed': 'Завершено',
  'appt.refused': 'Відмова',
  'schedule.allDoctors': 'Усі лікарі',
  'schedule.allRooms': 'Усі кабінети',
  'schedule.sumActive': 'Записів',
  'schedule.sumConfirmed': 'Підтверджено',
  'schedule.sumWalkIns': 'Без запису',
  'schedule.sumCancelled': 'Скасовано',
  'schedule.sumFlagged': 'З позначками',
  'schedule.walkIn': 'без запису',
  'schedule.phone': 'Телефон',
  'schedule.comment': 'Коментар',
  'schedule.number': 'Номер',
  'draft.care': 'Догляд',
  'draft.diet': 'Харчування',
  'draft.warning': 'Тривожні ознаки',
  'draft.uncertainties': 'Невпевненості (для лікаря)',
  'draft.followType': 'Тип контролю',
  'draft.inDays': 'Через днів',
  'draft.followReason': 'Причина контролю',
  'draft.route': 'Шлях',
  'draft.days': 'Днів',
  'draft.notes': 'Примітки',
  'draft.withFood': 'з їжею',
  'draft.fromTranscript': 'з розмови',
  'draft.fromRecord': 'з картки',
  'draft.generating': 'ШІ пише чернетку…',
  'draft.revoke': 'Відкликати',
  'draft.revokeTitle': 'Відкликати рекомендації?',
  'draft.revokeText': 'Клієнт більше не бачитиме їх у застосунку.',
  'draft.revoked': 'Рекомендації відкликано',
  'draft.record': 'Картка візиту',
  'draft.anamnesis': 'Анамнез',
  'draft.inRecord': 'Рекомендація в Enote',
  'draft.noTranscript': 'Транскрипту немає',
  'draft.noTranscriptHint': 'Сесію в кабінеті ще не підтверджено для цього візиту.',
  'rec.draft': 'чернетка',
  'rec.published': 'надіслано',
  'rec.rejected': 'відхилено',
  'rec.revoked': 'відкликано',
  'follow.none': 'Не потрібен',
  'follow.control_visit': 'Контрольний огляд',
  'follow.lab': 'Аналізи',
  'follow.vaccination': 'Вакцинація',
  'common.add': 'Додати',
  'doctor.notMapped': 'Ваш обліковий запис не пов’язано з лікарем Enote — попросіть адміністратора зв’язати його в «Користувачі».',
  'doctor.needRecommendation': 'Візити без рекомендацій',
  'doctor.allWritten': 'Усі рекомендації написано',
  'doctor.makeBrief': 'Підготувати бриф',
  'calls.allOperators': 'Усі оператори',
  'calls.details': 'Деталі дзвінка',
  'calls.empty': 'Дзвінків за період немає',
  'calls.history': 'Історія аналізів',
  'calls.managerAttention': 'Увага менеджера',
  'calls.ownerAttention': 'Увага власника',
  'calls.needsAttention': 'Потребує уваги',
  'calls.noAnalysis': 'Аналізу ще немає',
  'calls.noHits': 'У транскриптах нічого не знайдено',
  'calls.routes': 'Маршрут',
  'calls.searchTranscripts': 'Пошук у транскриптах',
  'calls.waiting': 'Очікування',
  'calls.st.answered': 'прийнятий',
  'calls.st.missed': 'пропущений',
  'calls.st.no_answer': 'без відповіді',
  'calls.st.busy': 'зайнято',
  'calls.st.failed': 'помилка',
  'clients.blacklisted': 'Чорний список',
  'clients.unreliable': 'Ненадійний',
  'clients.calls': 'Дзвінків',
  'clients.contactPersons': 'Контактні особи',
  'clients.curator': 'Куратор',
  'clients.messages': 'повідомлень у чаті: {n}',
  'clients.name': 'Клієнт',
  'clients.nextAppt': 'Наступний запис',
  'clients.primary': ' основний',
  'clients.refreshed': 'Оновлення з Enote поставлено в чергу',
  'common.loadMore': 'Показати ще',
  'missed.taskCreated': 'Завдання «передзвонити» створено',
  'missed.taskExists': 'Завдання вже є',
  'pet.activeRx': 'Активні призначення',
  'pet.aggressive': 'Агресивна',
  'pet.blood': 'Група крові',
  'pet.diet': 'Раціон',
  'pet.doctor': 'Лікуючий лікар',
  'pet.indicators': 'Показники',
  'pet.labOrders': 'Аналізи',
  'pet.labPending': 'очікує',
  'pet.markReviewed': 'Переглянуто — відкрити клієнту',
  'pet.neutered': 'стерилізована',
  'pet.noValues': 'Результатів ще немає',
  'pet.planned': 'план',
  'pet.reviewed': 'Результат відкрито клієнту',
  'pet.reviewedBy': 'переглянуто: {who}, {date}',
  'pet.trend': 'Динаміка',
  'session.clips': 'Кліпів',
  'session.details': 'Сесія',
  'session.speakers': 'Мовці',
  'session.speech': 'Мовлення',
  'timeline.kinds': 'Типи подій',
  'tl.appointment': 'Записи',
  'tl.visit': 'Візити',
  'tl.lab_order': 'Аналізи',
  'tl.prescription': 'Призначення',
  'tl.vaccination': 'Щеплення',
  'tl.payment': 'Оплати',
  'tl.call': 'Дзвінки',
  'tl.rating': 'Оцінки',
  'clientapp.channels': 'Канали',
  'clientapp.clientId': 'ID клієнта в Bridge',
  'clientapp.clientIdHint': 'Скопіюйте з адреси картки клієнта (/clients/…)',
  'clientapp.kiosk': 'Кіоск оцінок',
  'clientapp.kioskDisable': 'Вимкнути кіоск',
  'clientapp.kioskDisableText': 'Планшет на рецепції перестане приймати оцінки.',
  'clientapp.kioskEnable': 'Увімкнути й створити токен',
  'clientapp.kioskNew': 'Новий токен створено — введіть його на планшеті',
  'clientapp.kioskOff': 'вимкнено',
  'clientapp.kioskOn': 'працює',
  'clientapp.kioskRegen': 'Згенерувати новий токен',
  'clientapp.kioskText': 'Планшет на рецепції збирає оцінки візитів. Старий токен перестає працювати після генерації нового.',
  'clientapp.link': 'Прив’язати',
  'clientapp.linkTitle': 'Прив’язати {name} до клієнта',
  'clientapp.linked': 'Обліковий запис прив’язано',
  'clientapp.minutes': 'Хвилин',
  'clientapp.relation': 'Хто це для клієнта',
  'clientapp.response': 'Відповідь клієнту',
  'clientapp.revoked': 'відкликано',
  'clientapp.st.open': 'Відкриті',
  'clientapp.st.new': 'Нові',
  'clientapp.st.in_progress': 'В роботі',
  'clientapp.st.confirmed': 'Підтверджені',
  'clientapp.st.declined': 'Відхилені',
  'clientapp.st.cancelled': 'Скасовані',
  'clientapp.kind.booking': 'запис',
  'clientapp.kind.cancel': 'скасування',
  'clientapp.kind.cancellation': 'скасування',
  'clientapp.kind.new_pet': 'нова тварина',
  'clientapp.kind.pet_add': 'нова тварина',
  'clientapp.tod.morning': 'зранку',
  'clientapp.tod.afternoon': 'вдень',
  'clientapp.tod.evening': 'ввечері',
  'clientapp.rel.owner': 'Власник',
  'clientapp.rel.family': 'Член родини',
  'clientapp.rel.caretaker': 'Опікун',
  'clientapp.take': 'Взяти в роботу',
  'clientapp.taken': 'Заявку взято в роботу',
  'clientapp.unlink': 'Відв’язати',
  'clientapp.unlinkText': 'Застосунок втратить доступ до даних клієнта «{name}».',
  'clientapp.unlinkTitle': 'Відв’язати обліковий запис?',
  'clientapp.unlinked': 'Доступ відкликано',
  'common.saved': 'Збережено',
  'doctor.notMappedShort': 'Обліковий запис не зв’язано з лікарем Enote',
  'finance.actual': 'факт',
  'finance.allFops': 'Усі ФОП',
  'finance.avgCheck': 'Середній чек',
  'finance.card': 'Картка',
  'finance.cash': 'Готівка',
  'finance.displayName': 'Назва для звітів',
  'finance.docs': 'документів: {n}',
  'finance.exported': 'Експортовано рядків: {n}',
  'finance.fiscalExpected': 'До фіскалізації',
  'finance.flagsN': 'розбіжностей: {n}',
  'finance.fops': 'ФОП',
  'finance.gap': 'Не пробито',
  'finance.group.day': 'День',
  'finance.group.org': 'ФОП',
  'finance.group.department': 'Відділення',
  'finance.group.doctor': 'Лікар',
  'finance.group.service_group': 'Група послуг',
  'finance.groupBy': 'Групувати за',
  'finance.last30': 'За 30 днів: {n} оплат, {sum}',
  'finance.method': 'Спосіб оплати',
  'finance.m.cash': 'готівка',
  'finance.m.card': 'картка',
  'finance.m.mixed': 'змішана',
  'finance.m.bonus': 'бонуси',
  'finance.m.other': 'інше',
  'finance.net': 'Чисті надходження',
  'finance.netByDay': 'Надходження по днях',
  'finance.noFop': 'ФОП не вказано',
  'finance.notFop': 'не ФОП',
  'finance.paid': 'Оплачено',
  'finance.payments': 'Оплати',
  'finance.paymentsSummary': 'Оплат: {n} на {total}; повернення {refunds}',
  'finance.prevPeriod': 'Попередній період',
  'finance.receiptFop': 'ФОП чека',
  'finance.refunds': 'Повернення',
  'finance.salesCount': 'Продажів',
  'finance.share': 'Частка',
  'finance.taxGroup': 'Група ЄП',
  'finance.total': 'Разом',
  'finance.vsPrev': 'до попереднього',
  'finance.flag.partially_paid': 'Частково оплачено',
  'finance.flag.fop_unknown': 'ФОП не визначено',
  'insights.acknowledge': 'Взяв до уваги',
  'insights.acknowledged': 'прийнято',
  'insights.severity': 'Важливість',
  'kpi.labTurnaround': 'Медіана готовності аналізів',
  'kpi.vaccCompliance': 'вакцинації вчасно',
  'kpi.answered': 'Прийнято',
  'kpi.intent': 'З наміром записатися',
  'quality.allScores': 'Усі оцінки',
  'quality.byMonth': 'Місяць',
  'quality.comment': 'Коментар',
  'quality.five': 'П’ятірок',
  'quality.low': 'Низьких оцінок',
  'quality.ratings': 'Оцінки',
  'quality.source': 'Джерело',
  'quality.tags': 'Теги',
  'quality.fs.open': 'Відкриті',
  'quality.fs.overdue': 'Прострочені',
  'quality.fs.resolved': 'Вирішені',
  'today.noUpcoming': 'Більше записів сьогодні немає',
  'marketing.noSegmentsHint': 'Створіть сегмент — лічильник клієнтів оновлюється одразу.',
  'marketing.accounts': 'застосунків: {n}',
  'marketing.description': 'Опис',
  'marketing.f.lastVisitAfter': 'Візит після',
  'marketing.f.lastVisitBefore': 'Останній візит до',
  'marketing.f.noVisitMonths': 'Без візитів, міс.',
  'marketing.f.hasApp': 'Є застосунок',
  'marketing.f.hasTelegram': 'Є Telegram',
  'marketing.vacDue': 'скоро (30 днів)',
  'marketing.vacOverdue': 'прострочено',
  'marketing.sample': 'Приклад (псевдонімізовано)',
  'marketing.deleteTitle': 'Видалити сегмент?',
  'marketing.exportTitle': 'Експорт сегмента',
  'marketing.exportText': 'Вкажіть мету експорту — вона потрапить в аудит.',
  'marketing.purpose': 'Мета',
  'marketing.min': 'від',
  'marketing.max': 'до',
  'marketing.title': 'Заголовок',
  'marketing.ch.any': 'Бажаний канал клієнта',
  'marketing.ch.push': 'Push у застосунку',
  'marketing.ch.telegram': 'Telegram',
  'marketing.ch.sms': 'SMS',
  'marketing.st.draft': 'чернетка',
  'marketing.st.scheduled': 'заплановано',
  'marketing.st.sending': 'надсилається',
  'marketing.st.sent': 'надіслано',
  'marketing.st.cancelled': 'скасовано',
  'marketing.cancel': 'Скасувати кампанію',
  'marketing.schedule': 'Запланувати відправку',
  'marketing.scheduledToast': 'Кампанію заплановано',
  'marketing.segmentClients': 'Клієнтів у сегменті',
  'marketing.eligible': 'Отримають',
  'marketing.noConsent': 'Без згоди',
  'marketing.noChannel': 'Без каналу',
  'marketing.results': 'Результат за {n} днів',
  'marketing.conversion': 'Конверсія',
  'inbox.assigned': 'Відповідальний',
  'inbox.clients': 'Клієнти',
  'inbox.closed': 'Закриті',
  'inbox.open': 'Відкриті',
  'inbox.noAppAccount': 'У клієнта немає облікового запису в застосунку або Telegram — листування ще не було.',
  'inbox.notLinked': 'Обліковий запис не прив’язано до клієнта',
  'inbox.pick': 'Оберіть розмову',
  'inbox.search': 'Ім’я або телефон',
  'inbox.takeMine': 'Взяти собі',
  'rooms.cameras': 'Камери',
  'rooms.sessions': 'Сесії в кабінетах',
  'rooms.disabled': 'вимкнено',
  'rooms.gap': 'пауза {s} с',
  'rooms.gapLabel': 'Пауза між кліпами, с',
  'rooms.inRoom': 'у кабінеті «{room}»',
  'rooms.lastClip': 'Останній кліп',
  'rooms.mapText': 'Попереднє призначення закінчиться з цього моменту; сесії буде перебудовано.',
  'rooms.notAssigned': 'кабінет не призначено',
  'rooms.recordings': 'записів: {n}',
  'rooms.remap': 'Змінити кабінет',
  'rooms.room': 'Кабінет',
  'rooms.roomIdHint': 'Список кабінетів Enote потребує права clients.read — показано кабінети з історії.',
  'rooms.searchTranscripts': 'Пошук у розмовах у кабінетах',
  'fact.discount_amount': 'Знижка',
  'journey.notFound': 'Подорож не знайдено',
  'journey.notFoundHint': 'Для цього запису чи візиту ще не зібрано подорож.',
  'draft.fromAi': 'Чернетка ШІ',
  'draft.published': 'Надіслано клієнту {when}',
  'draft.awaiting': 'Чекає на лікаря',
  'draft.stale': 'застаріла',
  'draft.staleHint': 'Дані візиту змінилися після генерації — перевірте уважно або перегенеруйте.',
  'doctor.allDoctors': 'уся клініка',
  'draft.st.ready': 'готова',
  'draft.st.stale': 'застаріла',
  'draft.st.generating': 'генерується',
  'draft.st.failed': 'помилка',
  'doctor.queue': 'Черга',
  'doctor.queueEmpty': 'Усі рекомендації підтверджено',

  // inventory (Склад)
  'nav.inventory': 'Склад',
  'inventory.subtitle': 'Залишки й рух товарів з Enote',
  'inventory.subtitleSynced': 'Залишки й рух товарів з Enote · оновлено {when}',
  'inventory.tabStock': 'Залишки',
  'inventory.tabAlerts': 'Сповіщення',
  'inventory.warehouses': 'Склади',
  'inventory.allWarehouses': 'Усі склади',
  'inventory.everything': 'Разом з утилізацією й віртуальними',
  'inventory.kind.physical': 'Склади клініки',
  'inventory.kind.personal': 'Запаси лікарів',
  'inventory.kind.disposal': 'Утилізація',
  'inventory.kind.virtual': 'Віртуальні',
  'inventory.kindShort.physical': 'склад',
  'inventory.kindShort.personal': 'лікар',
  'inventory.kindShort.disposal': 'утилізація',
  'inventory.kindShort.virtual': 'віртуальний',
  'inventory.otherWarehouses': 'Утилізація й віртуальні ({n})',
  'inventory.item': 'Товар',
  'inventory.group': 'Група',
  'inventory.unit': 'Од.',
  'inventory.qty': 'Кількість',
  'inventory.qtyStock': 'Залишок на складах',
  'inventory.min': 'Мінімум',
  'inventory.minShort': 'мін. {n}',
  'inventory.minTotal': 'Мінімум (усього)',
  'inventory.value': 'Вартість',
  'inventory.lastMovement': 'Останній рух',
  'inventory.inStock': 'Позицій у наявності',
  'inventory.positions': 'у списку: {n}',
  'inventory.totalValue': 'Вартість запасів',
  'inventory.atCost': 'за собівартістю',
  'inventory.unitCost': 'Собівартість од.',
  'inventory.costValue': 'Сума за собівартістю',
  'inventory.salePrice': 'Ціна реалізації',
  'inventory.saleValue': 'Сума реалізації',
  'inventory.totalSale': 'Вартість за цінами реалізації',
  'inventory.atSalePrice': 'за прайсом Enote',
  'inventory.negative': 'Від’ємні залишки',
  'inventory.lowStock': 'Нижче мінімуму',
  'inventory.low': 'мало',
  'inventory.showOnly': 'показати лише їх',
  'inventory.empty': 'На вибраних складах немає залишків',
  'inventory.search': 'Пошук: назва, артикул, група',
  'inventory.onlyNegative': 'Лише від’ємні',
  'inventory.onlyLow': 'Нижче мінімуму',
  'inventory.includeZero': 'З нульовими',
  'inventory.alert.negative': 'Від’ємні залишки',
  'inventory.alert.low': 'Нижче мінімуму',
  'inventory.alert.dead': 'Без руху понад {days} дн.',
  'inventory.alert.disposal': 'На складах утилізації',
  'inventory.alertNone': 'Усе гаразд',
  'inventory.deadPartial': 'Історія руху є лише з {date}: показано товари без руху відтоді.',
  'inventory.warehouse': 'Склад',
  'inventory.allStock': 'усі склади',
  'inventory.never': 'не було',
  'inventory.more': 'Ще {n} — звузьте вибір складу',
  'inventory.byWarehouse': 'Залишки по складах',
  'inventory.noBalance': 'Немає залишків на жодному складі',
  'inventory.movements': 'Рух',
  'inventory.tabBalance': 'Залишки',
  'inventory.tabSales': 'Продажі',
  'inventory.sales.open': 'Продажі за період',
  'inventory.sales.last30': '30 днів',
  'inventory.sales.last90': '90 днів',
  'inventory.sales.last365': '12 місяців',
  'inventory.sales.ytd': 'З початку року',
  'inventory.sales.byDay': 'По днях',
  'inventory.sales.byWeek': 'По тижнях',
  'inventory.sales.byMonth': 'По місяцях',
  'inventory.sales.qty': 'Продано',
  'inventory.sales.revenue': 'Виручка',
  'inventory.sales.avgPrice': 'Середня ціна',
  'inventory.sales.documents': 'Чеків і візитів',
  'inventory.sales.retail': 'Роздріб (чеки)',
  'inventory.sales.visits': 'У візитах',
  'inventory.sales.metricQty': 'Кількість',
  'inventory.sales.metricRevenue': 'Виручка',
  'inventory.sales.empty': 'За цей період продажів немає',
  'inventory.sales.chart': 'Продажі за період',
  'inventory.sales.note': 'Роздрібні чеки та позиції візитів з Enote; виручка — після знижок.',
  'inventory.since': 'з {date}',
  'inventory.noMovements': 'Руху за цей період не було',
  'inventory.openVisit': 'візит',
  'inventory.thresholds': 'Мінімальний залишок',
  'inventory.doc.supply': 'Надходження',
  'inventory.doc.transfer': 'Переміщення',
  'inventory.doc.supplier_return': 'Повернення постачальнику',
  'inventory.doc.customer_return': 'Повернення від клієнта',
  'inventory.doc.visit': 'Візит',
  'inventory.doc.sale': 'Продаж',
  'inventory.doc.inventory': 'Інвентаризація',
  'inventory.doc.write_off': 'Списання',
  'inventory.doc.surplus': 'Оприбуткування',
  'inventory.doc.service_act': 'Акт наданих послуг',
  'inventory.doc.assembly': 'Комплектація',

  // clinic processes (checklists)
  'nav.processes': 'Процеси',
  'nav.processMine': 'Мої чеклісти',
  'nav.processCalendar': 'Календар регламенту',
  'nav.processTemplates': 'Шаблони й розклади',
  'nav.processNorms': 'Нормативи',
  'permGroup.processes': 'Процеси клініки',
  'perm.process.run': 'Виконання чеклістів',
  'perm.process.manage': 'Шаблони, розклади й нормативи чеклістів',
  'process.mineTitle': 'Мої чеклісти',
  'process.mineSubtitle': 'Чеклісти для вас і вашої ролі: прострочені — першими. Час — київський.',
  'process.start': 'Почати чекліст',
  'process.startTitle': 'Почати чекліст',
  'process.startHint': 'Оберіть чекліст — він з’явиться у вашому списку й відкриється одразу.',
  'process.startButton': 'Почати',
  'process.template': 'Чекліст',
  'process.noTemplates': 'Чеклістів ще немає',
  'process.noTemplatesHint': 'Створіть власний або додайте стандартні чеклісти клініки з регламентів.',
  'process.noArea': 'Без напряму',
  'process.scope': 'Чиї чеклісти',
  'process.scopeMine': 'Мої',
  'process.scopeAll': 'Усі',
  'process.statusFilter': 'Статус',
  'process.statusOpenAll': 'Усі відкриті',
  'process.area': 'Напрям',
  'process.allAreas': 'Усі напрями',
  'process.branch': 'Філія',
  'process.allBranches': 'Усі філії',
  'process.anyBranch': 'Будь-яка філія',
  'process.zone': 'Зона / кабінет',
  'process.zoneHint': 'Наприклад: «Кабінет 2», «ВРІТ, бокс 3»',
  'process.onlyOverdue': 'Лише прострочені',
  'process.emptyMine': 'Усі чеклісти виконано',
  'process.emptyMineHint': 'Нові з’являться за розкладом. Щоб пройти чекліст позапланово, натисніть «Почати чекліст».',
  'process.showDone': 'Показати завершені за {n} днів',
  'process.recentDone': 'Нещодавно завершені',
  'process.noneDone': 'За цей час завершених чеклістів немає.',
  'process.dueAt': 'до {when}',
  'process.doneAtBy': 'Завершено {when} · {who}',
  'process.overdue': 'Прострочено',
  'process.attention': 'Потребує уваги',
  'process.attentionHint': 'Є значення поза допустимими межами',
  'process.status.planned': 'Заплановано',
  'process.status.open': 'Не розпочато',
  'process.status.in_progress': 'Виконується',
  'process.status.done': 'Виконано',
  'process.status.cancelled': 'Скасовано',
  'process.progress': '{answered} з {total}',
  'process.missingRequired': 'обов’язкових не заповнено: {n}',
  'process.assignee': 'Виконавець: {who}',
  'process.version': 'версія {n}',
  'process.versionShort': 'v{n}',
  'process.cancelledReason': 'Скасовано: {reason}',
  'process.saving': 'Зберігаємо…',
  'process.saved': 'Усе збережено',
  'process.notSaved': 'Не збережено — перевірте значення',
  'process.cancelRun': 'Скасувати чекліст',
  'process.complete': 'Завершити',
  'process.fillRequired': 'Заповніть обов’язкові пункти ({n}) — їх позначено червоним.',
  'process.required': 'Обов’язково',
  'process.requiredMissing': 'Не заповнено',
  'process.onlyRole': 'Заповнює: {role}',
  'process.outOfRange': 'Поза нормою! Допустимо: {range}',
  'process.allowedRange': 'Допустимо: {range}',
  'process.normLine': 'Норматив «{title}»: {value}',
  'process.normToConfirm': 'Потребує підтвердження',
  'process.normConfirmed': 'Підтверджено',
  'process.answeredBy': '{who} · {when}',
  'process.signaturePlaceholder': 'ПІБ',
  'process.choose': 'Оберіть…',
  'process.photoPlaceholder': 'Номери файлів через кому',
  'process.photoNote': 'Завантаження фото — у наступній версії. Поки вкажіть номер файлу або посилання.',
  'process.unknownType': 'Невідомий тип пункту: {type}',
  'process.notANumber': 'Введіть число, наприклад 4,5',
  'process.cancelTitle': 'Скасувати чекліст?',
  'process.cancelHint': 'Чекліст закриється без виконання. Причина збережеться в журналі.',
  'process.cancelReason': 'Причина',
  'process.calendarSubtitle': 'Регламентні роботи за місяць: заплановані, виконані й прострочені. Час — київський.',
  'process.print': 'Друк журналу',
  'process.modeGrid': 'Місяць',
  'process.modeList': 'Список',
  'process.legend': 'Позначення',
  'process.showLess': 'згорнути',
  'process.calendarEmpty': 'У цьому місяці регламентних робіт немає',
  'process.journalTitle': 'Журнал виконання регламентних робіт · {period}',
  'process.col.when': 'Дата й час',
  'process.col.checklist': 'Чекліст',
  'process.col.zone': 'Зона',
  'process.col.status': 'Статус',
  'process.col.who': 'Хто виконав',
  'process.col.rhythm': 'Ритм',
  'process.col.assignee': 'Виконавець',
  'process.col.due': 'Час на виконання',
  'process.col.escalation': 'Ескалація',
  'process.col.next': 'Наступний',
  'process.col.active': 'Увімкнено',
  'process.col.version': 'Версія',
  'process.col.state': 'Стан',
  'process.col.updated': 'Оновлено',
  'process.col.norm': 'Норматив',
  'process.col.value': 'Значення',
  'process.col.unit': 'Одиниця',
  'process.col.source': 'Джерело',
  'process.templatesSubtitle': 'Чеклісти клініки та розклади, за якими вони з’являються у персоналу',
  'process.tabTemplates': 'Шаблони',
  'process.tabSchedules': 'Розклади',
  'process.showArchived': 'Показати архівні',
  'process.seedDefaults': 'Додати стандартні чеклісти',
  'process.seeded': 'Стандартні чеклісти, розклади (на паузі) й нормативи додано',
  'process.active': 'Активний',
  'process.archived': 'В архіві',
  'process.editNamed': 'Редагувати «{title}»',
  'process.newTemplate': 'Новий чекліст',
  'process.editTemplate': 'Редагування чекліста',
  'process.editHint': 'Зміни пунктів публікуються як нова версія; розпочаті чеклісти лишаються на своїй версії.',
  'process.createTemplate': 'Створити',
  'process.publish': 'Опублікувати',
  'process.versionNote': 'Зміни пунктів = нова версія',
  'process.templateCreated': 'Чекліст створено (версія 1)',
  'process.versionPublished': 'Опубліковано версію {n}',
  'process.templateSavedSame': 'Збережено. Пункти не змінилися — версія та сама.',
  'process.sectionN': 'Розділ {n}',
  'process.itemN': 'Пункт {n}',
  'process.moveUp': 'Вище',
  'process.moveDown': 'Нижче',
  'process.removeSection': 'Видалити розділ',
  'process.removeItem': 'Видалити пункт',
  'process.addItem': 'Додати пункт',
  'process.addSection': 'Додати розділ',
  'process.anyone': 'Будь-хто',
  'process.noNorm': 'Без нормативу',
  'process.field.title': 'Назва',
  'process.field.key': 'Ключ',
  'process.field.keyHint': 'Латиниця, цифри й «_»; після створення не змінюється',
  'process.field.keyFixed': 'Ключ не змінюється',
  'process.field.description': 'Опис і джерело (регламент)',
  'process.field.active': 'Активний — можна запускати',
  'process.field.sectionTitle': 'Назва розділу',
  'process.field.label': 'Текст пункту',
  'process.field.type': 'Тип',
  'process.field.itemKey': 'Ключ пункту',
  'process.field.role': 'Хто заповнює',
  'process.field.unit': 'Одиниця',
  'process.field.min': 'Мінімум',
  'process.field.max': 'Максимум',
  'process.field.choices': 'Варіанти',
  'process.field.choicesHint': 'Кожен варіант з нового рядка, щонайменше два',
  'process.field.hint': 'Підказка',
  'process.field.norm': 'Норматив',
  'process.itemType.check': 'Галочка',
  'process.itemType.number': 'Число',
  'process.itemType.text': 'Текст',
  'process.itemType.choice': 'Вибір варіанта',
  'process.itemType.photo': 'Фото',
  'process.itemType.signature': 'Підпис (ПІБ)',
  'process.err.required': 'Обов’язкове поле',
  'process.err.key': 'Лише латиниця a–z, цифри й «_»',
  'process.err.keyDuplicate': 'Такий ключ уже є в чеклісті',
  'process.err.choices': 'Потрібно щонайменше два варіанти',
  'process.err.number': 'Має бути число',
  'process.err.range': 'Мінімум більший за максимум',
  'process.err.noItems': 'Додайте хоча б один пункт',
  'process.err.unknown': 'Невідоме значення',
  'process.err.fix': 'Виправте позначені поля',
  'process.err.everyN': 'Від 1 до 1000',
  'process.schedulesHint': 'Розклад створює чеклісти автоматично. Нові розклади стандартних чеклістів стоять на паузі — перевірте й увімкніть.',
  'process.newSchedule': 'Новий розклад',
  'process.editScheduleTitle': 'Редагування розкладу',
  'process.editSchedule': 'Редагувати розклад «{title}»',
  'process.noSchedules': 'Розкладів ще немає',
  'process.scheduleActive': 'Розклад «{title}» увімкнено',
  'process.schedulePaused': 'Розклад на паузі',
  'process.scheduleResumed': 'Розклад увімкнено',
  'process.person': 'Окрема людина',
  'process.nobody': 'Нікому',
  'process.paused': 'На паузі',
  'process.rhythmPreview': 'Ритм: {rhythm}',
  'process.field.scheduleTitle': 'Назва в розкладі',
  'process.field.scheduleTitleHint': 'Необов’язково, напр. «Контроль препаратної (вечір)»',
  'process.field.freq': 'Повторювати',
  'process.field.everyN': 'Кожні N',
  'process.field.startsAt': 'Перший раз',
  'process.field.startsAtHint': 'Київський час; наступні — о тій самій годині',
  'process.field.until': 'До (необов’язково)',
  'process.field.weekdays': 'Лише в дні тижня',
  'process.field.months': 'Лише в місяці',
  'process.field.assigneeRole': 'Виконує роль',
  'process.field.due': 'Виконати за, хв',
  'process.field.escalate': 'Ескалація після простроч., хв',
  'process.field.escalateHint': 'Порожньо — без ескалації',
  'process.field.escalateRole': 'Кого повідомити',
  'process.field.scheduleOn': 'Розклад увімкнено',
  'process.freq.hours': 'Щогодинно / кожні N год',
  'process.freq.days': 'Щодня / кожні N днів',
  'process.freq.weeks': 'Щотижня / кожні N тижнів',
  'process.freq.months': 'Щомісяця / кожні N місяців',
  'process.freq.years': 'Щороку',
  'process.rhythm.hourly': 'щогодини',
  'process.rhythm.everyHours': 'кожну {n} год|кожні {n} год|кожні {n} год',
  'process.rhythm.daily': 'щодня',
  'process.rhythm.everyDays': 'кожен {n} день|кожні {n} дні|кожні {n} днів',
  'process.rhythm.weekly': 'щотижня',
  'process.rhythm.everyWeeks': 'кожен {n} тиждень|кожні {n} тижні|кожні {n} тижнів',
  'process.rhythm.monthly': 'щомісяця',
  'process.rhythm.everyMonths': 'кожен {n} місяць|кожні {n} місяці|кожні {n} місяців',
  'process.rhythm.yearly': 'щороку',
  'process.rhythm.everyYears': 'кожен {n} рік|кожні {n} роки|кожні {n} років',
  'process.rhythm.onWeekday': 'в {day}',
  'process.rhythm.dayOfMonth': '{day}-го',
  'process.rhythm.at': 'о {time}',
  'process.weekdaysShort': 'пн|вт|ср|чт|пт|сб|нд',
  'process.monthsShort': 'січ|лют|бер|квіт|трав|черв|лип|серп|вер|жовт|лист|груд',
  'process.dur.min': '{n} хв',
  'process.dur.hours': '{n} год',
  'process.dur.days': '{n} дн',
  'process.normsSubtitle': 'Числа й терміни з регламентів, на які спираються чеклісти. Кожна зміна зберігається в історії.',
  'process.normsSearch': 'Пошук нормативу',
  'process.noNorms': 'Нормативів ще немає',
  'process.normsToConfirm': 'Потребують підтвердження: {n} — у документах різні значення.',
  'process.normHistoryOf': 'Історія «{title}»',
  'process.normEditOf': 'Змінити «{title}»',
  'process.normHistory': 'Історія змін',
  'process.normNoHistory': 'Змін ще не було',
  'process.normValue': 'Значення (JSON)',
  'process.normInvalidJson': 'Некоректний JSON. Число — 15, текст — "18:00", діапазон — {"min": 2, "max": 8}',
  'process.normPreview': 'Буде показано як: {value}',
  'process.normReason': 'Причина зміни',
  'process.normReasonHint': 'Наприклад, номер наказу чи рішення планерки',
  'process.normUnit': 'Одиниця: {unit}',
  'process.system': 'Система',
  'process.area.clinic': 'Клініка',
  'process.area.surgery': 'Хірургія',
  'process.area.ward': 'ВРІТ',
  'process.area.cash': 'Каса',
  'process.area.call_center': 'Колл-центр',
  'process.area.safety': 'Безпека',
  'process.area.management': 'Керівництво',
  'process.branch.kharkiv': 'Харків',
  'process.branch.kyiv': 'Київ',
  'today.overdueChecklists': 'Прострочені чеклісти',
  'nav.vrit': 'ВРІТ',
  'nav.vritHandover': 'Передача зміни ВРІТ',
  'perm.vrit.read': 'Дошка ВРІТ і моніторинг',
  'perm.vrit.manage': 'ВРІТ: прийом, передачі, звіти, виписка',
  'vrit.title': 'ВРІТ',
  'vrit.subtitle': 'Бокси, пацієнти, категорії та відлік до наступного контролю. Оновлюється щохвилини.',
  'vrit.allBranches': 'Усі філії',
  'vrit.branchFilter': 'Філія',
  'vrit.admit': 'Прийняти пацієнта',
  'vrit.boxes': 'Бокси',
  'vrit.tariffs': 'Тарифи',
  'vrit.morning': 'Ранкова передача',
  'vrit.statOccupied': 'Зайнято',
  'vrit.statFree': 'Вільно',
  'vrit.statOverdue': 'Прострочений контроль',
  'vrit.statReports': 'Без звіту власнику сьогодні',
  'vrit.statHandovers': 'Передачі чекають підтвердження',
  'vrit.visitHours': 'Відвідування: {from}–{to}, до {min} хв',
  'vrit.visitHoursHint': 'Критичних — будь-коли за погодженням з лікарем ВРІТ.',
  'vrit.toConfirm': 'потребує підтвердження',
  'vrit.monitoringNorms': 'Частота моніторингу',
  'vrit.noBoxes': 'Боксів ще немає',
  'vrit.noBoxesHint': 'Додайте бокси й клітки кожної філії — тоді на дошці з’являться місця для пацієнтів.',
  'vrit.noBoxesHintStaff': 'Попросіть адміністратора або лікаря ВРІТ додати бокси.',
  'vrit.free': 'Вільний',
  'vrit.admitHere': 'Прийняти сюди',
  'vrit.cat.n': 'Кат. {n}',
  'vrit.cat.vent': 'ШВЛ',
  'vrit.category': 'Категорія',
  'vrit.min': '{n} хв',
  'vrit.hours': '{n} год',
  'vrit.days': '{n} д',
  'vrit.overdueBy': 'прострочено на {d}',
  'vrit.checkIn': 'контроль через {d}',
  'vrit.continuous': 'постійно (окрема людина)',
  'vrit.perHour': '{from}–{to} рази на годину',
  'vrit.every': 'кожні {d}',
  'vrit.daysIn': 'День {n}',
  'vrit.kg': 'кг',
  'vrit.hr': 'ЧСС',
  'vrit.rr': 'ЧДР',
  'vrit.perDay': '{amount}/доба',
  'vrit.debt': 'Борг {amount}',
  'vrit.deposit': 'Депозит {amount}',
  'vrit.balanceZero': 'Баланс 0',
  'vrit.reportSent': 'Звіт надіслано',
  'vrit.reportNotSent': 'Звіт ще не надіслано',
  'vrit.warnings': 'Увага: {list}',
  'vrit.warn.no_consent_pack': 'немає підписаного пакета згод',
  'vrit.warn.no_prepayment': 'немає передоплати',
  'vrit.warn.unvaccinated': 'невакцинований',
  'vrit.warn.risk_not_informed': 'власника не поінформовано письмово про ризик',
  'vrit.warn.no_weight': 'немає ваги',
  'vrit.warn.no_tariff': 'тариф не налаштовано',
  'vrit.kind.standard': 'Звичайний',
  'vrit.kind.oxygen': 'Кисневий',
  'vrit.kind.isolation': 'Ізолятор',
  'vrit.kind.neonatal': 'Неонатальний',
  'vrit.vacc.vaccinated': 'Вакцинований',
  'vrit.vacc.unvaccinated': 'Невакцинований',
  'vrit.vacc.unknown': 'Статус невідомий',
  'vrit.band.lt10': 'до 10 кг',
  'vrit.band.10_25': '10–25 кг',
  'vrit.band.25_50': '25–50 кг',
  'vrit.band.gt50': 'понад 50 кг',
  'vrit.status.admitted': 'У ВРІТ',
  'vrit.status.discharged': 'Виписаний',
  'vrit.status.died': 'Помер',
  'vrit.status.transferred': 'Переведений',
  'vrit.admitTitle': 'Прийняти пацієнта у ВРІТ',
  'vrit.admitHint': 'Пацієнт і візит — з Enote. Тариф пропонується за категорією й вагою.',
  'vrit.searchPatient': 'Пацієнт',
  'vrit.searchPlaceholder': 'Кличка, власник або чип',
  'vrit.searchHint': 'Введіть щонайменше 2 символи',
  'vrit.noPatients': 'Нікого не знайдено',
  'vrit.alreadyAdmitted': 'вже у ВРІТ',
  'vrit.box': 'Бокс',
  'vrit.chooseBox': 'Оберіть бокс',
  'vrit.noFreeBoxes': 'Вільних боксів немає',
  'vrit.visit': 'Візит Enote',
  'vrit.noVisit': 'Без візиту',
  'vrit.weight': 'Вага, кг',
  'vrit.weightHint': 'Остання вага з Enote: {w} кг',
  'vrit.diagnosis': 'Діагноз',
  'vrit.vaccination': 'Вакцинація',
  'vrit.docs': 'Документи при заселенні',
  'vrit.doc.consent_pack': 'Згода на стаціонар + договір оплати підписані',
  'vrit.doc.prepayment': 'Передоплату внесено',
  'vrit.doc.risk_informed': 'Власника письмово поінформовано про ризик (невакцинований)',
  'vrit.unvaccinatedWarn': 'Невакцинованих приймають лише за показаннями та з письмовим інформуванням власника.',
  'vrit.admitButton': 'Прийняти',
  'vrit.admitted': 'Пацієнта прийнято',
  'vrit.boxesTitle': 'Бокси й клітки',
  'vrit.boxesHint': 'Код — як на табличці боксу. Бокс із пацієнтом не можна вивести з використання.',
  'vrit.boxCode': 'Код боксу',
  'vrit.boxKind': 'Тип',
  'vrit.addBox': 'Додати бокс',
  'vrit.inUse': 'У використанні',
  'vrit.tariffsTitle': 'Тарифи ВРІТ за добу',
  'vrit.tariffsHint': 'Категорія × вага. Порожнє поле — тариф не налаштовано. Зберігається при виході з поля.',
  'vrit.tariffsHidden': 'Тарифи — це гроші: їх бачать лише ролі з доступом до оплат.',
  'vrit.tabMonitoring': 'Моніторинг',
  'vrit.tabHandover': 'Передачі',
  'vrit.tabReport': 'Звіт власнику',
  'vrit.tabDischarge': 'Виписка',
  'vrit.owner': 'Власник',
  'vrit.admittedAt': 'Прийнято',
  'vrit.responsible': 'Відповідальний',
  'vrit.lastCheck': 'Останній контроль',
  'vrit.never': 'ще не було',
  'vrit.openInEnote': 'Картка пацієнта',
  'vrit.changeCategory': 'Змінити категорію',
  'vrit.moveTo': 'Перевести в бокс',
  'vrit.monitorTitle': 'Новий контроль',
  'vrit.monitorHint': 'Збереження контролю перезапускає відлік до наступного.',
  'vrit.field.temperature_c': 'Температура, °C',
  'vrit.field.heart_rate': 'ЧСС, уд/хв',
  'vrit.field.resp_rate': 'ЧДР, /хв',
  'vrit.field.weight_kg': 'Вага, кг',
  'vrit.field.mucosa': 'Слизові',
  'vrit.field.mental': 'Ментальний статус',
  'vrit.field.appetite': 'Апетит',
  'vrit.field.stool': 'Стілець',
  'vrit.field.urine': 'Сеча',
  'vrit.field.note': 'Нотатка',
  'vrit.saveCheck': 'Зберегти контроль',
  'vrit.checkSaved': 'Контроль збережено',
  'vrit.invalidNumber': 'Введіть число',
  'vrit.addNote': 'Додати нотатку',
  'vrit.notePlaceholder': 'Нотатка без контролю (не перезапускає відлік)',
  'vrit.log': 'Журнал',
  'vrit.logEmpty': 'Записів ще немає. Додайте перший контроль.',
  'vrit.ev.admission': 'Прийом у ВРІТ',
  'vrit.ev.monitoring': 'Контроль',
  'vrit.ev.note': 'Нотатка',
  'vrit.ev.category_change': 'Категорія {from} → {to}',
  'vrit.ev.box_change': 'Бокс {from} → {to}',
  'vrit.ev.update': 'Дані змінено',
  'vrit.ev.owner_report': 'Звіт власнику',
  'vrit.ev.discharge': 'Закрито: {outcome}',
  'vrit.newHandover': 'Нова передача пацієнта',
  'vrit.scenario': 'Сценарій',
  'vrit.sc.stable': 'Стабільний з прийому',
  'vrit.sc.critical': 'Критичний з приймального',
  'vrit.sc.after_urgent': 'Після ургентної операції',
  'vrit.sc.after_planned': 'Після планової операції',
  'vrit.sc.unvaccinated': 'Невакцинований',
  'vrit.sc.shift': 'Передача зміни',
  'vrit.handOver': 'Передати',
  'vrit.handoverSaved': 'Передачу збережено — чекає підтвердження лікаря ВРІТ',
  'vrit.receive': 'Прийняв',
  'vrit.received': 'Прийняв {who}, {when}',
  'vrit.waiting': 'Чекає підтвердження',
  'vrit.handedBy': '{who}, {when}',
  'vrit.noHandovers': 'Передач ще немає',
  'vrit.requiredMissing': 'Заповніть обов’язкові поля: {n}',
  'vrit.reportTitle': 'Щоденний звіт власнику',
  'vrit.reportHint': 'Надсилається в застосунок і Telegram-бот власника. Фото й відео поки надсилайте окремо.',
  'vrit.rp.stool': 'Стілець',
  'vrit.rp.urination': 'Сечовипускання',
  'vrit.rp.appetite': 'Апетит',
  'vrit.rp.activity': 'Активність',
  'vrit.rp.mucosa': 'Слизові',
  'vrit.rp.temperature': 'Температура',
  'vrit.rp.dynamics': 'Динаміка',
  'vrit.rp.tests': 'Аналізи',
  'vrit.reportText': 'Текст для власника',
  'vrit.preview': 'Попередній перегляд',
  'vrit.send': 'Надіслати власнику',
  'vrit.reportSentOk': 'Звіт надіслано',
  'vrit.reportNoRecipients': 'У власника немає застосунку чи бота — зателефонуйте йому. Звіт збережено.',
  'vrit.recipients': 'Отримувачів: {n}',
  'vrit.balanceIncluded': 'До звіту буде додано баланс рахунку',
  'vrit.balanceOff': 'Баланс не додається (налаштування vrit.owner_report_include_balance вимкнено)',
  'vrit.alreadySentToday': 'Сьогодні звіт уже надсилали',
  'vrit.pastReports': 'Надіслані звіти',
  'vrit.noReports': 'Звітів ще не надсилали',
  'vrit.dischargeHint': 'Виписує лише лікар ВРІТ: спочатку чекліст (папка рекомендацій, згода, навчання власника, чеки), потім «Виписати».',
  'vrit.startChecklist': 'Відкрити чекліст виписки',
  'vrit.checklistNotStarted': 'Чекліст виписки ще не відкрито',
  'vrit.checklistDone': 'Чекліст виписки виконано',
  'vrit.checklistOpen': 'Чекліст виписки відкрито — заповніть його',
  'vrit.dischargeButton': 'Виписати',
  'vrit.otherOutcome': 'Інший результат',
  'vrit.outcome.died': 'Помер',
  'vrit.outcome.transferred': 'Переведено',
  'vrit.outcomeNote': 'Що сталося',
  'vrit.closeStay': 'Закрити перебування',
  'vrit.stayClosed': 'Перебування закрито',
  'vrit.closedAt': '{status}: {when}, {who}',
  'vrit.morningTitle': 'Ранкова передача зміни ВРІТ',
  'vrit.morningSubtitle': 'Кожен пацієнт з полями, заповненими з дошки й журналу. Доповніть, передайте — вхідна зміна підтверджує.',
  'vrit.pendingTitle': 'Чекають підтвердження',
  'vrit.noPatientsInWard': 'У ВРІТ цієї філії зараз немає пацієнтів',
  'vrit.general': 'Загальне',
  'vrit.handOverShift': 'Передати зміну',
  'vrit.shiftSaved': 'Зміну передано — чекає підтвердження',
  'vrit.lastShift': 'Остання передача: {when}, {who}',
  'vrit.recentNotes': 'За добу',
  'vrit.required': 'Обов’язкове поле',
  'vrit.juniorCannotReceive': 'Приймати пацієнта чи зміну й виписувати може лише лікар.',
  // Stock control (B13)
  'process.area.stock': 'Склад',
  'stock.tabOrder': 'До замовлення',
  'stock.tabCounts': 'Інвентаризації',
  'stock.tabExpiry': 'Терміни придатності',
  'stock.toOrderCount': 'До замовлення',
  'stock.levelsCount': 'Позицій з мін/опт: {n}',
  'stock.orderValue': 'Орієнтовна сума замовлення',
  'stock.consumptionWindow': 'Витрата рахується за',
  'stock.days': '{n} дн.',
  'stock.leadDays': 'З запасом на доставку {n} дн.',
  'stock.noLead': 'Замовлення до оптимального рівня',
  'stock.showAllLevels': 'Усі позиції з мін/опт',
  'stock.importLevels': 'Імпорт мін/опт',
  'stock.csvForSupplier': 'CSV для постачальника',
  'stock.exported': 'Завантажено позицій: {n}',
  'stock.nothingToOrder': 'Нічого не потрібно замовляти — усі залишки не нижче мінімуму',
  'stock.noLevels': 'Мінімальні й оптимальні залишки ще не задані',
  'stock.noLevelsHint': 'Імпортуйте їх з таблиці «Склади» або задайте мінімум в картці товару на вкладці «Залишки».',
  'stock.balancesAsOf': 'Залишки Enote станом на {when}',
  'stock.minOpt': 'Мін / опт',
  'stock.dailyUse': 'Витрата/день',
  'stock.cover': 'Вистачить на',
  'stock.toOrder': 'Замовити',
  'stock.below': 'нижче мінімуму',
  'stock.soon': 'скоро закінчиться',
  'stock.importHint': 'Вставте рядки з таблиці: назва або артикул, мінімум, оптимум (через табуляцію, «;» або «,»). Рядок заголовка пропускається.',
  'stock.check': 'Перевірити',
  'stock.importN': 'Імпортувати {n}',
  'stock.levelTotal': 'Разом по всіх складах',
  'stock.importText': 'Рядки з таблиці',
  'stock.importExample': 'Наприклад: Бинт стерильний;5;20',
  'stock.importPreview': 'Знайдено позицій: {matched}, з проблемами: {issues}',
  'stock.importLine': 'Рядок {n}',
  'stock.imported': 'Імпортовано рівнів: {n}',
  'stock.issue.not_found': 'товар не знайдено',
  'stock.issue.ambiguous': 'кілька товарів з такою назвою',
  'stock.issue.bad_number': 'некоректне число',
  'stock.issue.optimal_below_min': 'оптимум менший за мінімум',
  'stock.optimal': 'Оптимум',
  'stock.optShort': 'опт {n}',
  'stock.enoteReadOnly': 'Інвентаризації й партії зберігаються в Bridge; залишки в Enote не змінюються.',
  'stock.plans': 'Графік інвентаризацій',
  'stock.setupPlans': 'Створити розклади за нормативом',
  'stock.plansCreated': 'Розклади створено на паузі — перевірте й увімкніть',
  'stock.noWarehouses': 'Складів ще немає — дочекайтеся синхронізації з Enote',
  'stock.rhythm': 'Частота',
  'stock.whoCounts': 'Хто рахує',
  'stock.nextCount': 'Наступна',
  'stock.lastCount': 'Остання',
  'stock.paused': 'на паузі',
  'stock.suggested': 'За нормативом: {rhythm}',
  'stock.noPlan': 'Розкладу немає',
  'stock.openCount': 'Відкрити опис',
  'stock.diffN': 'розбіжностей: {n}',
  'stock.never': 'ще не було',
  'stock.countNow': 'Порахувати зараз',
  'stock.editPlan': 'Змінити розклад «{name}»',
  'stock.freqOne.days': 'щодня',
  'stock.freqOne.weeks': 'щотижня',
  'stock.freqOne.months': 'щомісяця',
  'stock.freqMany.days': 'кожні {n} дні',
  'stock.freqMany.weeks': 'кожні {n} тижні',
  'stock.freqMany.months': 'кожні {n} місяці',
  'stock.freqUnit.days': 'Дні',
  'stock.freqUnit.weeks': 'Тижні',
  'stock.freqUnit.months': 'Місяці',
  'stock.planTitle': 'Інвентаризація: {name}',
  'stock.freq': 'Одиниця',
  'stock.everyN': 'Кожні N',
  'stock.firstCount': 'Перша інвентаризація',
  'stock.firstCountHint': 'За замовчуванням — завтра о 09:00',
  'stock.dueHours': 'Виконати протягом, год',
  'stock.dueHint': 'За замовчуванням: щодня — 10 год, кожні 2–3 дні — доба, інакше — 3 дні',
  'stock.countRole': 'Роль',
  'stock.countPerson': 'Або конкретна людина',
  'stock.doctor': 'Лікар (власник складу)',
  'stock.doctorHint': 'Особистий склад рахує сам лікар; нестачі потрапляють у звіт для ЗП',
  'stock.byRole': 'За роллю',
  'stock.planActive': 'Розклад увімкнено',
  'stock.history': 'Інвентаризаційні описи',
  'stock.status': 'Статус',
  'stock.allStatuses': 'Усі статуси',
  'stock.sheetStatus.open': 'Відкрито',
  'stock.sheetStatus.done': 'Завершено',
  'stock.sheetStatus.cancelled': 'Скасовано',
  'stock.noCounts': 'Інвентаризацій ще не було',
  'stock.noCountsHint': 'Налаштуйте графік вище або натисніть «Порахувати зараз» біля складу.',
  'stock.when': 'Коли',
  'stock.counted': 'Пораховано',
  'stock.shortage': 'Нестача',
  'stock.surplus': 'Надлишок',
  'stock.shortageValue': 'Нестача, сума',
  'stock.shortagesTitle': 'Нестачі особистих складів за місяць (для ЗП)',
  'stock.month': 'Місяць',
  'stock.noShortages': 'Нестач за цей місяць немає',
  'stock.expired': 'Прострочено',
  'stock.expiringSoon': 'Спливає за {n} дн.',
  'stock.inWindow': 'Партій у вікні {n} дн.',
  'stock.alertsAt': 'Сповіщення за {days} дн.',
  'stock.searchBatch': 'Пошук товару чи серії',
  'stock.window': 'Вікно',
  'stock.withinDays': 'До {n} днів',
  'stock.addBatch': 'Додати партію',
  'stock.addBatchHint': 'Для препаратів, у яких Enote не має терміну придатності: серія з упаковки, дата і кількість.',
  'stock.noExpiring': 'Немає партій з терміном, що спливає',
  'stock.noExpiringHint': 'Терміни беруться з Enote (якщо є) і з партій, доданих тут кнопкою «Додати партію».',
  'stock.batch': 'Серія',
  'stock.expiresOn': 'Придатний до',
  'stock.sourceLocal': 'Bridge',
  'stock.expiredBadge': 'прострочено',
  'stock.daysLeft': '{n} дн.',
  'stock.markUsed': 'Використано: {name}',
  'stock.markDisposed': 'Списано: {name}',
  'stock.err.qty': 'Кількість — число не менше 0',
  'stock.change': 'Змінити',
  'stock.backToCounts': 'Інвентаризації',
  'stock.filter.all': 'Усі',
  'stock.filter.uncounted': 'Не пораховані',
  'stock.filter.diff': 'З розбіжністю',
  'stock.sheetTitle': 'Інвентаризація: {name}',
  'stock.doctorIs': 'Лікар: {name}',
  'stock.dueAt': 'Термін: {when}',
  'stock.snapshotAt': 'Залишки Enote на {when}',
  'stock.snapshotCreated': 'Опис створено {when}',
  'stock.openChecklist': 'Чекліст',
  'stock.differences': 'Розбіжностей',
  'stock.addItem': 'Додати товар',
  'stock.completeCount': 'Завершити інвентаризацію',
  'stock.emptySheet': 'За Enote на складі нічого немає',
  'stock.emptySheetHint': 'Якщо на полиці щось є — додайте товар кнопкою «Додати товар».',
  'stock.expected': 'За Enote',
  'stock.countedQty': 'Факт',
  'stock.difference': 'Різниця',
  'stock.note': 'Примітка',
  'stock.added': 'додано',
  'stock.countedOf': 'Фактична кількість: {name}',
  'stock.noteOf': 'Примітка: {name}',
  'stock.completeHint': 'Розбіжностей: {diffs}, нестача {shortage} од. Після завершення опис не редагується.',
  'stock.countDone': 'Інвентаризацію завершено',
  'stock.uncountedLeft': 'Не пораховано позицій: {n}',
  'stock.fillExpected': 'Решту {n} позицій вважати такими, що збігаються з Enote',
  'stock.countNote': 'Зауваження',
  'stock.countNoteHint': 'Причини нестач, прострочені препарати — потрапить у чекліст',
  'stock.addItemHint': 'Товар є на полиці, але його немає в залишках Enote цього складу.',
  'stock.add': 'Додати',
  'stock.openSheet': 'Відкрити інвентаризаційний опис →',
  // staff and HR (B11)
  'nav.staff': 'Персонал',
  'nav.staffBriefings': 'Журнал інструктажів',
  'nav.staffMe': 'Моє навчання',
  'perm.hr.read': 'Персонал: картки, інструктажі, сертифікати, навички',
  'perm.hr.manage': 'Персонал: редагування карток, журнал інструктажів, тести',
  'process.area.hr': 'Персонал',
  'today.staffDue': 'Персонал: інструктажі й документи',
  'hr.title': 'Персонал',
  'hr.subtitle': 'Картки працівників, онбординг і офбординг, інструктажі, сертифікати й медогляди, навички й тести. Лише посада, філіал, роботодавець, дати, статус і ментор — без зарплат, паспортів і податкових номерів.',
  'hr.tabEmployees': 'Працівники',
  'hr.tabMatrix': 'Матриця навичок',
  'hr.tabTests': 'Тести',
  'hr.employee': 'Працівник',
  'hr.fullName': 'Прізвище та ім’я',
  'hr.fullNameHint': 'Можна не заповнювати, якщо обрано обліковий запис або працівника Enote',
  'hr.account': 'Обліковий запис Bridge',
  'hr.noAccount': 'Без облікового запису',
  'hr.enoteEmployee': 'Працівник Enote',
  'hr.position': 'Посада',
  'hr.role': 'Роль',
  'hr.roleHint': 'Для матриці навичок',
  'hr.branch': 'Філіал',
  'hr.employer': 'Роботодавець (ФОП / ТОВ)',
  'hr.status': 'Статус',
  'hr.status.trainee': 'Стажист / слухач',
  'hr.status.probation': 'Випробувальний строк',
  'hr.status.staff': 'У штаті',
  'hr.status.left': 'Звільнений',
  'hr.allWorking': 'Усі працюючі',
  'hr.hiredOn': 'Дата початку роботи',
  'hr.probationUntil': 'Кінець випробувального строку',
  'hr.leftOn': 'Дата звільнення',
  'hr.mentor': 'Ментор',
  'hr.highRisk': 'Роботи підвищеної небезпеки',
  'hr.highRiskHint': 'Роботи підвищеної небезпеки (повторний інструктаж з ОП кожні 3 міс.)',
  'hr.privacyNote': 'Bridge не зберігає зарплати, паспортні дані, ІПН, адреси й телефони працівників — вони лишаються в кадровому обліку.',
  'hr.addEmployee': 'Додати працівника',
  'hr.editEmployee': 'Картка працівника',
  'hr.employeeFormHint': 'Пов’яжіть картку з обліковим записом Bridge (сповіщення, власна картка) і працівником Enote.',
  'hr.sync': 'Картки з облікових записів',
  'hr.syncDone': 'Створено карток: {n}',
  'hr.searchEmployee': 'Пошук за іменем або посадою',
  'hr.attention': 'Увага',
  'hr.overdueN': 'прострочено: {n}',
  'hr.dueSoonN': 'скоро: {n}',
  'hr.noEmployees': 'Карток працівників ще немає',
  'hr.noEmployeesHint': 'Натисніть «Картки з облікових записів» — Bridge створить картки для всіх працівників з обліковими записами й підтягне посаду з Enote. Стажистів без облікового запису додайте вручну.',
  'hr.noEmployeesRole': 'Немає працівників з цією роллю',
  'hr.dueTitle': 'Потребує уваги',
  'hr.nothingDue': 'Усі інструктажі й документи в порядку',
  'hr.needsAttention': 'Потребує уваги',
  'hr.days.today': 'сьогодні',
  'hr.days.in': 'через {n} дн',
  'hr.days.ago': 'прострочено на {n} дн',
  'hr.state.missing': 'Не проведено',
  'hr.state.overdue': 'Прострочено',
  'hr.state.due': 'Скоро',
  'hr.state.ok': 'Гаразд',
  'hr.state.expired': 'Термін минув',
  'hr.state.expiring': 'Спливає',
  'hr.state.valid': 'Дійсний',
  'hr.state.open': 'Безстроковий',
  'hr.state.ending': 'Закінчується',
  'hr.tab.onboarding': 'Онбординг',
  'hr.tab.briefings': 'Інструктажі',
  'hr.tab.certificates': 'Сертифікати й медогляди',
  'hr.tab.skills': 'Навички',
  'hr.startOnboarding': 'Почати онбординг',
  'hr.startOffboarding': 'Почати офбординг',
  'hr.offboardingNeedsDate': 'Спершу вкажіть дату звільнення в картці',
  'hr.noRuns': 'Онбординг ще не запускався',
  'hr.noRunsHint': '«Почати онбординг» створить чеклісти: документи й доступи, інструктажі й допуск, перший тиждень з ментором і зустрічі через 4 і 8 тижнів, 6 і 12 місяців.',
  'hr.area': 'Напрям',
  'hr.area.ohs': 'Охорона праці',
  'hr.area.fire': 'Пожежна безпека',
  'hr.area.civil': 'Цивільний захист',
  'hr.allAreas': 'Усі напрями',
  'hr.kind': 'Вид інструктажу',
  'hr.kind.introductory': 'Вступний',
  'hr.kind.primary': 'Первинний',
  'hr.kind.repeat': 'Повторний',
  'hr.kind.unscheduled': 'Позаплановий',
  'hr.kind.targeted': 'Цільовий',
  'hr.kindHint.introductory': 'Новим працівникам, практикантам — до 1 години',
  'hr.kindHint.primary': 'До початку роботи на робочому місці; від нього рахується повторний',
  'hr.kindHint.repeat': 'ОП: кожні 3 міс. (підвищена небезпека) / 6 міс.; пожежна — 6 міс.',
  'hr.kindHint.unscheduled': 'Нові норми, заміна обладнання, порушення, перерва понад 30/60 днів',
  'hr.kindHint.targeted': 'Ліквідація аварії, роботи за наряд-допуском',
  'hr.allKinds': 'Усі види',
  'hr.topic': 'Інструкція / тема',
  'hr.topicHint': 'Наприклад, «ІЗВР-1 вступний інструктаж»',
  'hr.reason': 'Причина',
  'hr.givenOn': 'Дата',
  'hr.instructor': 'Хто проводив',
  'hr.instructorHint': 'Порожньо — ви',
  'hr.nextDue': 'Наступний',
  'hr.nextOn': 'наступний {date}',
  'hr.never': 'не проводився',
  'hr.signature': 'Підтвердження',
  'hr.acknowledge': 'Підтверджую',
  'hr.acknowledged': 'Підтверджено',
  'hr.notAcknowledged': 'Не підтверджено',
  'hr.recordBriefing': 'Записати інструктаж',
  'hr.recordBriefingHint': 'Групу можна записати одним разом. Первинний і повторний інструктажі призначають дату наступного за нормативами.',
  'hr.recordFor': 'Записати ({n})',
  'hr.whoBriefed': 'Кого проінструктовано: {n}',
  'hr.noBriefings': 'Записів у журналі ще немає',
  'hr.noBriefingsHint': 'Внесіть останній інструктаж з паперового журналу — від нього Bridge порахує дату наступного.',
  'hr.journalTitle': 'Журнал інструктажів',
  'hr.journalSubtitle': 'Охорона праці, пожежна безпека й цивільний захист. Паперовий журнал лишається юридичним документом — цю сторінку можна роздрукувати.',
  'hr.journalEmptyHint': 'Натисніть «Записати інструктаж» і перенесіть записи з паперових журналів №3 і №4.',
  'hr.briefingsDue': 'Інструктажі, які потрібно провести: {n}',
  'hr.print': 'Друк',
  'hr.deleteEntry': 'Видалити запис',
  'hr.deleteEntryTitle': 'Видалити запис з журналу?',
  'hr.certKind': 'Вид',
  'hr.cert.ohs_training': 'Навчання з охорони праці',
  'hr.cert.fire_minimum': 'Пожежно-технічний мінімум',
  'hr.cert.radiation': 'Радіаційна безпека',
  'hr.cert.medical_exam': 'Медичний огляд',
  'hr.cert.first_aid': 'Домедична допомога',
  'hr.cert.electrical': 'Група з електробезпеки',
  'hr.cert.other': 'Інше',
  'hr.certTitle': 'Назва',
  'hr.issuedOn': 'Видано',
  'hr.validUntil': 'Дійсний до',
  'hr.validUntilHint': 'Нагадування за 30 днів',
  'hr.noExpiry': 'безстроково',
  'hr.note': 'Примітка',
  'hr.noteHint': 'Без номерів документів і персональних даних',
  'hr.addCertificate': 'Додати сертифікат',
  'hr.editCertificate': 'Сертифікат',
  'hr.certificateHint': 'Навчання з ОП (посадові особи — раз на 3 роки, інші — щороку), пожежно-технічний мінімум, радіаційна безпека, медогляди.',
  'hr.deleteCertificate': 'Видалити сертифікат?',
  'hr.noCertificates': 'Сертифікатів і медоглядів ще немає',
  'hr.noCertificatesHint': 'Додайте дату медогляду й посвідчення з терміном дії — Bridge нагадає, коли він спливатиме.',
  'hr.skill': 'Навичка / тема',
  'hr.level': 'Рівень',
  'hr.level.0': 'Не розпочато',
  'hr.level.1': 'Теорія',
  'hr.level.2': 'Під наглядом',
  'hr.level.3': 'Самостійно',
  'hr.levelOf': 'Рівень: {skill}',
  'hr.addRep': 'Виконано ще раз: {skill}',
  'hr.addReps': 'Додати виконань',
  'hr.repsHint': 'Виконано / потрібно за нормативом',
  'hr.repsDone': 'Виконано {n} з {required} за нормативом',
  'hr.notRequired': 'не для цієї ролі',
  'hr.otherSkills': 'Інше',
  'hr.noSkills': 'Навичок для цієї ролі ще немає',
  'hr.noSkillsHint': 'Каталог навичок заповнює HR; «Додати стандартні» на вкладці «Тести» додасть первинне навчання асистентів (18 тем).',
  'hr.matrixHint': 'Рівні записують HR і ментор працівника. «Самостійно» — лише після потрібної кількості виконань.',
  'hr.tests': 'Тести',
  'hr.test': 'Тест',
  'hr.newTest': 'Новий тест',
  'hr.editTest': 'Тест',
  'hr.seed': 'Додати стандартні',
  'hr.noTests': 'Тестів ще немає',
  'hr.noTestsHint': '«Додати стандартні» створить тест з охорони праці та пожежної безпеки, чеклісти онбордингу й навички асистентів.',
  'hr.noTestsForMe': 'Для вас тестів поки немає',
  'hr.testMeta': 'Питань: {n} · прохідний бал {score}%',
  'hr.archived': 'в архіві',
  'hr.takeTest': 'Пройти',
  'hr.retake': 'Пройти ще раз',
  'hr.testTitle': 'Назва тесту',
  'hr.testKey': 'Ключ',
  'hr.testKeyHint': 'Латиницею, напр. vaccination_2026',
  'hr.testDescription': 'Опис',
  'hr.testSkill': 'Навичка',
  'hr.testSkillHint': 'Після успішного тесту рівень стане щонайменше «Теорія»',
  'hr.passScore': 'Прохідний бал, %',
  'hr.testActive': 'Активний',
  'hr.questionN': 'Питання {n}',
  'hr.choices': 'Варіанти відповіді',
  'hr.choicesHint': 'Кожен варіант з нового рядка',
  'hr.correctChoices': 'Правильні варіанти',
  'hr.addQuestion': 'Додати питання',
  'hr.removeQuestion': 'Видалити питання',
  'hr.testResults': 'Результати тестів',
  'hr.noAttempts': 'Тестів ще ніхто не проходив',
  'hr.score': 'Результат',
  'hr.finishedAt': 'Коли',
  'hr.passed': 'складено',
  'hr.failed': 'не складено',
  'hr.multiHint': 'кілька правильних',
  'hr.submitTest': 'Надіслати відповіді',
  'hr.answerAll': 'Дайте відповідь на всі питання',
  'hr.answerRight': 'Правильно',
  'hr.answerWrong': 'Неправильно',
  'hr.resultPassed': 'Тест складено: {score}%',
  'hr.resultFailed': 'Тест не складено: {score}% (потрібно {need}%)',
  'hr.resultCorrect': 'Правильних відповідей: {n} з {total}',
  'hr.meTitle': 'Моє навчання',
  'hr.meSubtitle': 'Мої інструктажі, сертифікати й медогляди, навички та тести.',
  'hr.myTests': 'Тести',
  'hr.noCard': 'Картки працівника ще немає',
  'hr.noCardHint': 'Її створює адміністратор (HR) у розділі «Персонал». Після цього тут з’являться ваші інструктажі, навички й тести.',
  'hr.err.name': 'Вкажіть ім’я або оберіть обліковий запис',
  'hr.err.leftOn': 'Для звільненого потрібна дата звільнення',
  'hr.err.leftOrder': 'Дата звільнення раніше за дату початку',
  'hr.err.probationOrder': 'Кінець випробувального строку раніше за дату початку',
  'hr.err.mentorSelf': 'Працівник не може бути своїм ментором',
  'hr.err.invalid': 'Перевірте значення',
  'hr.err.required': 'Обов’язкове поле',
  'hr.err.future': 'Інструктаж не можна записати наперед',
  'hr.err.certDates': '«Дійсний до» раніше за дату видачі',
  'hr.err.key': 'Лише a-z, 0-9 і _',
  'hr.err.questionText': 'Введіть текст питання',
  'hr.err.questionChoices': 'Потрібно щонайменше два варіанти',
  'hr.err.questionCorrect': 'Позначте правильний варіант',
  'hr.err.repsShort': '«Самостійно» — після {n} виконань',
}

export type Dict = { [K in keyof typeof uk]: string }
